/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WelcomeRouteImport } from './routes/welcome'
import { Route as ForbiddenRouteImport } from './routes/forbidden'
import { Route as CliLoginRouteImport } from './routes/cli-login'
import { Route as CheckoutRouteImport } from './routes/checkout'
import { Route as SplatRouteImport } from './routes/$'
import { Route as IndexRouteImport } from './routes/index'
import { Route as WorkspacesIndexRouteImport } from './routes/workspaces/index'
import { Route as WorkspacesWorkspaceIdRouteImport } from './routes/workspaces/$workspaceId'
import { Route as ProfileSettingsRouteImport } from './routes/profile/settings'
import { Route as ProfileAccountRouteImport } from './routes/profile/account'
import { Route as OauthInterstitialRouteImport } from './routes/oauth/interstitial'
import { Route as WorkspacesWorkspaceIdIndexRouteImport } from './routes/workspaces/$workspaceId/index'
import { Route as WorkspacesWorkspaceIdUsageRouteImport } from './routes/workspaces/$workspaceId/usage'
import { Route as WorkspacesWorkspaceIdSettingsRouteImport } from './routes/workspaces/$workspaceId/settings'
import { Route as WorkspacesWorkspaceIdProfileRouteImport } from './routes/workspaces/$workspaceId/profile'
import { Route as WorkspacesWorkspaceIdOnboardingRouteImport } from './routes/workspaces/$workspaceId/onboarding'
import { Route as WorkspacesWorkspaceIdLoadingBotRouteImport } from './routes/workspaces/$workspaceId/loading-bot'
import { Route as WorkspacesWorkspaceIdHomeRouteImport } from './routes/workspaces/$workspaceId/home'
import { Route as WorkspacesWorkspaceIdCreateBotRouteImport } from './routes/workspaces/$workspaceId/create-bot'
import { Route as WorkspacesWorkspaceIdCheckoutTriggerRouteImport } from './routes/workspaces/$workspaceId/checkout-trigger'
import { Route as WorkspacesWorkspaceIdChatbotsRouteImport } from './routes/workspaces/$workspaceId/chatbots_'
import { Route as WorkspacesWorkspaceIdBotsRouteImport } from './routes/workspaces/$workspaceId/bots_'
import { Route as WorkspacesWorkspaceIdBillingRouteImport } from './routes/workspaces/$workspaceId/billing'
import { Route as WorkspacesWorkspaceIdSplatRouteImport } from './routes/workspaces/$workspaceId/$'
import { Route as WorkspacesWorkspaceIdUsageIndexRouteImport } from './routes/workspaces/$workspaceId/usage/index'
import { Route as WorkspacesWorkspaceIdSettingsIndexRouteImport } from './routes/workspaces/$workspaceId/settings/index'
import { Route as WorkspacesWorkspaceIdIntegrationsIndexRouteImport } from './routes/workspaces/$workspaceId/integrations/index'
import { Route as WorkspacesWorkspaceIdUsageMonthlySummaryRouteImport } from './routes/workspaces/$workspaceId/usage/monthly-summary'
import { Route as WorkspacesWorkspaceIdUsageAiSpendRouteImport } from './routes/workspaces/$workspaceId/usage/ai-spend'
import { Route as WorkspacesWorkspaceIdSettingsMembersRouteImport } from './routes/workspaces/$workspaceId/settings/members'
import { Route as WorkspacesWorkspaceIdSettingsDetailsRouteImport } from './routes/workspaces/$workspaceId/settings/details'
import { Route as WorkspacesWorkspaceIdSettingsAuditsRouteImport } from './routes/workspaces/$workspaceId/settings/audits'
import { Route as WorkspacesWorkspaceIdSettingsSplatRouteImport } from './routes/workspaces/$workspaceId/settings/$'
import { Route as WorkspacesWorkspaceIdProfileSettingsRouteImport } from './routes/workspaces/$workspaceId/profile/settings'
import { Route as WorkspacesWorkspaceIdProfileAccountRouteImport } from './routes/workspaces/$workspaceId/profile/account'
import { Route as WorkspacesWorkspaceIdIntegrationsIntegrationIdRouteImport } from './routes/workspaces/$workspaceId/integrations/$integrationId'
import { Route as WorkspacesWorkspaceIdChatbotsBotIdRouteImport } from './routes/workspaces/$workspaceId/chatbots/$botId'
import { Route as WorkspacesWorkspaceIdBotsBotIdRouteImport } from './routes/workspaces/$workspaceId/bots/$botId'
import { Route as WorkspacesWorkspaceIdIntegrationsIntegrationIdIndexRouteImport } from './routes/workspaces/$workspaceId/integrations/$integrationId/index'
import { Route as WorkspacesWorkspaceIdBotsBotIdIndexRouteImport } from './routes/workspaces/$workspaceId/bots/$botId/index'
import { Route as WorkspacesWorkspaceIdIntegrationsIntegrationIdVersionsRouteImport } from './routes/workspaces/$workspaceId/integrations/$integrationId/versions'
import { Route as WorkspacesWorkspaceIdIntegrationsIntegrationIdSettingsRouteImport } from './routes/workspaces/$workspaceId/integrations/$integrationId/settings'
import { Route as WorkspacesWorkspaceIdIntegrationsIntegrationIdLogsRouteImport } from './routes/workspaces/$workspaceId/integrations/$integrationId/logs'
import { Route as WorkspacesWorkspaceIdIntegrationsIntegrationIdSplatRouteImport } from './routes/workspaces/$workspaceId/integrations/$integrationId/$'
import { Route as WorkspacesWorkspaceIdChatbotsBotIdSplatRouteImport } from './routes/workspaces/$workspaceId/chatbots/$botId/$'
import { Route as WorkspacesWorkspaceIdBotsBotIdWorkflowsRouteImport } from './routes/workspaces/$workspaceId/bots/$botId/workflows'
import { Route as WorkspacesWorkspaceIdBotsBotIdWebchatRouteImport } from './routes/workspaces/$workspaceId/bots/$botId/webchat'
import { Route as WorkspacesWorkspaceIdBotsBotIdVibeRouteImport } from './routes/workspaces/$workspaceId/bots/$botId/vibe'
import { Route as WorkspacesWorkspaceIdBotsBotIdUsersRouteImport } from './routes/workspaces/$workspaceId/bots/$botId/users'
import { Route as WorkspacesWorkspaceIdBotsBotIdSettingsRouteImport } from './routes/workspaces/$workspaceId/bots/$botId/settings'
import { Route as WorkspacesWorkspaceIdBotsBotIdOverviewRouteImport } from './routes/workspaces/$workspaceId/bots/$botId/overview'
import { Route as WorkspacesWorkspaceIdBotsBotIdNewChatRouteImport } from './routes/workspaces/$workspaceId/bots/$botId/new-chat'
import { Route as WorkspacesWorkspaceIdBotsBotIdNewBotRouteImport } from './routes/workspaces/$workspaceId/bots/$botId/new-bot'
import { Route as WorkspacesWorkspaceIdBotsBotIdNewAdkBotSetupRouteImport } from './routes/workspaces/$workspaceId/bots/$botId/new-adk-bot-setup'
import { Route as WorkspacesWorkspaceIdBotsBotIdLogsRouteImport } from './routes/workspaces/$workspaceId/bots/$botId/logs'
import { Route as WorkspacesWorkspaceIdBotsBotIdIntegrationsRouteImport } from './routes/workspaces/$workspaceId/bots/$botId/integrations'
import { Route as WorkspacesWorkspaceIdBotsBotIdHitlRouteImport } from './routes/workspaces/$workspaceId/bots/$botId/hitl'
import { Route as WorkspacesWorkspaceIdBotsBotIdFilesRouteImport } from './routes/workspaces/$workspaceId/bots/$botId/files'
import { Route as WorkspacesWorkspaceIdBotsBotIdEventsRouteImport } from './routes/workspaces/$workspaceId/bots/$botId/events'
import { Route as WorkspacesWorkspaceIdBotsBotIdConversationsRouteImport } from './routes/workspaces/$workspaceId/bots/$botId/conversations'
import { Route as WorkspacesWorkspaceIdBotsBotIdAnalyticsRouteImport } from './routes/workspaces/$workspaceId/bots/$botId/analytics'
import { Route as WorkspacesWorkspaceIdBotsBotIdSplatRouteImport } from './routes/workspaces/$workspaceId/bots/$botId/$'
import { Route as WorkspacesWorkspaceIdBotsBotIdWebchatIndexRouteImport } from './routes/workspaces/$workspaceId/bots/$botId/webchat/index'
import { Route as WorkspacesWorkspaceIdBotsBotIdTablesIndexRouteImport } from './routes/workspaces/$workspaceId/bots/$botId/tables/index'
import { Route as WorkspacesWorkspaceIdBotsBotIdSettingsIndexRouteImport } from './routes/workspaces/$workspaceId/bots/$botId/settings/index'
import { Route as WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesIndexRouteImport } from './routes/workspaces/$workspaceId/bots/$botId/knowledge-bases/index'
import { Route as WorkspacesWorkspaceIdBotsBotIdIssuesIndexRouteImport } from './routes/workspaces/$workspaceId/bots/$botId/issues/index'
import { Route as WorkspacesWorkspaceIdBotsBotIdTablesTableIdRouteImport } from './routes/workspaces/$workspaceId/bots/$botId/tables/$tableId'
import { Route as WorkspacesWorkspaceIdBotsBotIdSettingsGeneralRouteImport } from './routes/workspaces/$workspaceId/bots/$botId/settings/general'
import { Route as WorkspacesWorkspaceIdBotsBotIdSettingsAccessControlRouteImport } from './routes/workspaces/$workspaceId/bots/$botId/settings/access-control'
import { Route as WorkspacesWorkspaceIdBotsBotIdIssuesIssueIdRouteImport } from './routes/workspaces/$workspaceId/bots/$botId/issues/$issueId'
import { Route as WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdRouteImport } from './routes/workspaces/$workspaceId/bots/$botId/conversations/$conversationId'
import { Route as WorkspacesWorkspaceIdBotsBotIdConversationIdQueryMessageIdRouteImport } from './routes/workspaces/$workspaceId/bots/$botId/conversationIdQuery/$messageId'
import { Route as WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesKbIdIndexRouteImport } from './routes/workspaces/$workspaceId/bots/$botId/knowledge-bases/$kbId/index'
import { Route as WorkspacesWorkspaceIdBotsBotIdWebchatV2ShareRouteImport } from './routes/workspaces/$workspaceId/bots/$botId/webchat/v2/share'
import { Route as WorkspacesWorkspaceIdBotsBotIdWebchatV2IdentityRouteImport } from './routes/workspaces/$workspaceId/bots/$botId/webchat/v2/identity'
import { Route as WorkspacesWorkspaceIdBotsBotIdWebchatV2GeneralRouteImport } from './routes/workspaces/$workspaceId/bots/$botId/webchat/v2/general'
import { Route as WorkspacesWorkspaceIdBotsBotIdWebchatV2FeaturesRouteImport } from './routes/workspaces/$workspaceId/bots/$botId/webchat/v2/features'
import { Route as WorkspacesWorkspaceIdBotsBotIdWebchatV2DeploySettingsRouteImport } from './routes/workspaces/$workspaceId/bots/$botId/webchat/v2/deploy-settings'
import { Route as WorkspacesWorkspaceIdBotsBotIdWebchatV2AppearanceRouteImport } from './routes/workspaces/$workspaceId/bots/$botId/webchat/v2/appearance'
import { Route as WorkspacesWorkspaceIdBotsBotIdWebchatV2AdvancedSettingsRouteImport } from './routes/workspaces/$workspaceId/bots/$botId/webchat/v2/advanced-settings'
import { Route as WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesKbIdDsIdRouteImport } from './routes/workspaces/$workspaceId/bots/$botId/knowledge-bases/$kbId/$dsId'
import { Route as WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdMessagesMessageIdRouteImport } from './routes/workspaces/$workspaceId/bots/$botId/conversations/$conversationId/messages/$messageId'

const WelcomeRoute = WelcomeRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => rootRouteImport,
} as any)
const ForbiddenRoute = ForbiddenRouteImport.update({
  id: '/forbidden',
  path: '/forbidden',
  getParentRoute: () => rootRouteImport,
} as any)
const CliLoginRoute = CliLoginRouteImport.update({
  id: '/cli-login',
  path: '/cli-login',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckoutRoute = CheckoutRouteImport.update({
  id: '/checkout',
  path: '/checkout',
  getParentRoute: () => rootRouteImport,
} as any)
const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkspacesIndexRoute = WorkspacesIndexRouteImport.update({
  id: '/workspaces/',
  path: '/workspaces/',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkspacesWorkspaceIdRoute = WorkspacesWorkspaceIdRouteImport.update({
  id: '/workspaces/$workspaceId',
  path: '/workspaces/$workspaceId',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileSettingsRoute = ProfileSettingsRouteImport.update({
  id: '/profile/settings',
  path: '/profile/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileAccountRoute = ProfileAccountRouteImport.update({
  id: '/profile/account',
  path: '/profile/account',
  getParentRoute: () => rootRouteImport,
} as any)
const OauthInterstitialRoute = OauthInterstitialRouteImport.update({
  id: '/oauth/interstitial',
  path: '/oauth/interstitial',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkspacesWorkspaceIdIndexRoute =
  WorkspacesWorkspaceIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => WorkspacesWorkspaceIdRoute,
  } as any)
const WorkspacesWorkspaceIdUsageRoute =
  WorkspacesWorkspaceIdUsageRouteImport.update({
    id: '/usage',
    path: '/usage',
    getParentRoute: () => WorkspacesWorkspaceIdRoute,
  } as any)
const WorkspacesWorkspaceIdSettingsRoute =
  WorkspacesWorkspaceIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => WorkspacesWorkspaceIdRoute,
  } as any)
const WorkspacesWorkspaceIdProfileRoute =
  WorkspacesWorkspaceIdProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => WorkspacesWorkspaceIdRoute,
  } as any)
const WorkspacesWorkspaceIdOnboardingRoute =
  WorkspacesWorkspaceIdOnboardingRouteImport.update({
    id: '/onboarding',
    path: '/onboarding',
    getParentRoute: () => WorkspacesWorkspaceIdRoute,
  } as any)
const WorkspacesWorkspaceIdLoadingBotRoute =
  WorkspacesWorkspaceIdLoadingBotRouteImport.update({
    id: '/loading-bot',
    path: '/loading-bot',
    getParentRoute: () => WorkspacesWorkspaceIdRoute,
  } as any)
const WorkspacesWorkspaceIdHomeRoute =
  WorkspacesWorkspaceIdHomeRouteImport.update({
    id: '/home',
    path: '/home',
    getParentRoute: () => WorkspacesWorkspaceIdRoute,
  } as any)
const WorkspacesWorkspaceIdCreateBotRoute =
  WorkspacesWorkspaceIdCreateBotRouteImport.update({
    id: '/create-bot',
    path: '/create-bot',
    getParentRoute: () => WorkspacesWorkspaceIdRoute,
  } as any)
const WorkspacesWorkspaceIdCheckoutTriggerRoute =
  WorkspacesWorkspaceIdCheckoutTriggerRouteImport.update({
    id: '/checkout-trigger',
    path: '/checkout-trigger',
    getParentRoute: () => WorkspacesWorkspaceIdRoute,
  } as any)
const WorkspacesWorkspaceIdChatbotsRoute =
  WorkspacesWorkspaceIdChatbotsRouteImport.update({
    id: '/chatbots_',
    path: '/chatbots',
    getParentRoute: () => WorkspacesWorkspaceIdRoute,
  } as any)
const WorkspacesWorkspaceIdBotsRoute =
  WorkspacesWorkspaceIdBotsRouteImport.update({
    id: '/bots_',
    path: '/bots',
    getParentRoute: () => WorkspacesWorkspaceIdRoute,
  } as any)
const WorkspacesWorkspaceIdBillingRoute =
  WorkspacesWorkspaceIdBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => WorkspacesWorkspaceIdRoute,
  } as any)
const WorkspacesWorkspaceIdSplatRoute =
  WorkspacesWorkspaceIdSplatRouteImport.update({
    id: '/$',
    path: '/$',
    getParentRoute: () => WorkspacesWorkspaceIdRoute,
  } as any)
const WorkspacesWorkspaceIdUsageIndexRoute =
  WorkspacesWorkspaceIdUsageIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => WorkspacesWorkspaceIdUsageRoute,
  } as any)
const WorkspacesWorkspaceIdSettingsIndexRoute =
  WorkspacesWorkspaceIdSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => WorkspacesWorkspaceIdSettingsRoute,
  } as any)
const WorkspacesWorkspaceIdIntegrationsIndexRoute =
  WorkspacesWorkspaceIdIntegrationsIndexRouteImport.update({
    id: '/integrations/',
    path: '/integrations/',
    getParentRoute: () => WorkspacesWorkspaceIdRoute,
  } as any)
const WorkspacesWorkspaceIdUsageMonthlySummaryRoute =
  WorkspacesWorkspaceIdUsageMonthlySummaryRouteImport.update({
    id: '/monthly-summary',
    path: '/monthly-summary',
    getParentRoute: () => WorkspacesWorkspaceIdUsageRoute,
  } as any)
const WorkspacesWorkspaceIdUsageAiSpendRoute =
  WorkspacesWorkspaceIdUsageAiSpendRouteImport.update({
    id: '/ai-spend',
    path: '/ai-spend',
    getParentRoute: () => WorkspacesWorkspaceIdUsageRoute,
  } as any)
const WorkspacesWorkspaceIdSettingsMembersRoute =
  WorkspacesWorkspaceIdSettingsMembersRouteImport.update({
    id: '/members',
    path: '/members',
    getParentRoute: () => WorkspacesWorkspaceIdSettingsRoute,
  } as any)
const WorkspacesWorkspaceIdSettingsDetailsRoute =
  WorkspacesWorkspaceIdSettingsDetailsRouteImport.update({
    id: '/details',
    path: '/details',
    getParentRoute: () => WorkspacesWorkspaceIdSettingsRoute,
  } as any)
const WorkspacesWorkspaceIdSettingsAuditsRoute =
  WorkspacesWorkspaceIdSettingsAuditsRouteImport.update({
    id: '/audits',
    path: '/audits',
    getParentRoute: () => WorkspacesWorkspaceIdSettingsRoute,
  } as any)
const WorkspacesWorkspaceIdSettingsSplatRoute =
  WorkspacesWorkspaceIdSettingsSplatRouteImport.update({
    id: '/$',
    path: '/$',
    getParentRoute: () => WorkspacesWorkspaceIdSettingsRoute,
  } as any)
const WorkspacesWorkspaceIdProfileSettingsRoute =
  WorkspacesWorkspaceIdProfileSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => WorkspacesWorkspaceIdProfileRoute,
  } as any)
const WorkspacesWorkspaceIdProfileAccountRoute =
  WorkspacesWorkspaceIdProfileAccountRouteImport.update({
    id: '/account',
    path: '/account',
    getParentRoute: () => WorkspacesWorkspaceIdProfileRoute,
  } as any)
const WorkspacesWorkspaceIdIntegrationsIntegrationIdRoute =
  WorkspacesWorkspaceIdIntegrationsIntegrationIdRouteImport.update({
    id: '/integrations/$integrationId',
    path: '/integrations/$integrationId',
    getParentRoute: () => WorkspacesWorkspaceIdRoute,
  } as any)
const WorkspacesWorkspaceIdChatbotsBotIdRoute =
  WorkspacesWorkspaceIdChatbotsBotIdRouteImport.update({
    id: '/chatbots/$botId',
    path: '/chatbots/$botId',
    getParentRoute: () => WorkspacesWorkspaceIdRoute,
  } as any)
const WorkspacesWorkspaceIdBotsBotIdRoute =
  WorkspacesWorkspaceIdBotsBotIdRouteImport.update({
    id: '/bots/$botId',
    path: '/bots/$botId',
    getParentRoute: () => WorkspacesWorkspaceIdRoute,
  } as any)
const WorkspacesWorkspaceIdIntegrationsIntegrationIdIndexRoute =
  WorkspacesWorkspaceIdIntegrationsIntegrationIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => WorkspacesWorkspaceIdIntegrationsIntegrationIdRoute,
  } as any)
const WorkspacesWorkspaceIdBotsBotIdIndexRoute =
  WorkspacesWorkspaceIdBotsBotIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)
const WorkspacesWorkspaceIdIntegrationsIntegrationIdVersionsRoute =
  WorkspacesWorkspaceIdIntegrationsIntegrationIdVersionsRouteImport.update({
    id: '/versions',
    path: '/versions',
    getParentRoute: () => WorkspacesWorkspaceIdIntegrationsIntegrationIdRoute,
  } as any)
const WorkspacesWorkspaceIdIntegrationsIntegrationIdSettingsRoute =
  WorkspacesWorkspaceIdIntegrationsIntegrationIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => WorkspacesWorkspaceIdIntegrationsIntegrationIdRoute,
  } as any)
const WorkspacesWorkspaceIdIntegrationsIntegrationIdLogsRoute =
  WorkspacesWorkspaceIdIntegrationsIntegrationIdLogsRouteImport.update({
    id: '/logs',
    path: '/logs',
    getParentRoute: () => WorkspacesWorkspaceIdIntegrationsIntegrationIdRoute,
  } as any)
const WorkspacesWorkspaceIdIntegrationsIntegrationIdSplatRoute =
  WorkspacesWorkspaceIdIntegrationsIntegrationIdSplatRouteImport.update({
    id: '/$',
    path: '/$',
    getParentRoute: () => WorkspacesWorkspaceIdIntegrationsIntegrationIdRoute,
  } as any)
const WorkspacesWorkspaceIdChatbotsBotIdSplatRoute =
  WorkspacesWorkspaceIdChatbotsBotIdSplatRouteImport.update({
    id: '/$',
    path: '/$',
    getParentRoute: () => WorkspacesWorkspaceIdChatbotsBotIdRoute,
  } as any)
const WorkspacesWorkspaceIdBotsBotIdWorkflowsRoute =
  WorkspacesWorkspaceIdBotsBotIdWorkflowsRouteImport.update({
    id: '/workflows',
    path: '/workflows',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)
const WorkspacesWorkspaceIdBotsBotIdWebchatRoute =
  WorkspacesWorkspaceIdBotsBotIdWebchatRouteImport.update({
    id: '/webchat',
    path: '/webchat',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)
const WorkspacesWorkspaceIdBotsBotIdVibeRoute =
  WorkspacesWorkspaceIdBotsBotIdVibeRouteImport.update({
    id: '/vibe',
    path: '/vibe',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)
const WorkspacesWorkspaceIdBotsBotIdUsersRoute =
  WorkspacesWorkspaceIdBotsBotIdUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)
const WorkspacesWorkspaceIdBotsBotIdSettingsRoute =
  WorkspacesWorkspaceIdBotsBotIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)
const WorkspacesWorkspaceIdBotsBotIdOverviewRoute =
  WorkspacesWorkspaceIdBotsBotIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)
const WorkspacesWorkspaceIdBotsBotIdNewChatRoute =
  WorkspacesWorkspaceIdBotsBotIdNewChatRouteImport.update({
    id: '/new-chat',
    path: '/new-chat',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)
const WorkspacesWorkspaceIdBotsBotIdNewBotRoute =
  WorkspacesWorkspaceIdBotsBotIdNewBotRouteImport.update({
    id: '/new-bot',
    path: '/new-bot',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)
const WorkspacesWorkspaceIdBotsBotIdNewAdkBotSetupRoute =
  WorkspacesWorkspaceIdBotsBotIdNewAdkBotSetupRouteImport.update({
    id: '/new-adk-bot-setup',
    path: '/new-adk-bot-setup',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)
const WorkspacesWorkspaceIdBotsBotIdLogsRoute =
  WorkspacesWorkspaceIdBotsBotIdLogsRouteImport.update({
    id: '/logs',
    path: '/logs',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)
const WorkspacesWorkspaceIdBotsBotIdIntegrationsRoute =
  WorkspacesWorkspaceIdBotsBotIdIntegrationsRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)
const WorkspacesWorkspaceIdBotsBotIdHitlRoute =
  WorkspacesWorkspaceIdBotsBotIdHitlRouteImport.update({
    id: '/hitl',
    path: '/hitl',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)
const WorkspacesWorkspaceIdBotsBotIdFilesRoute =
  WorkspacesWorkspaceIdBotsBotIdFilesRouteImport.update({
    id: '/files',
    path: '/files',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)
const WorkspacesWorkspaceIdBotsBotIdEventsRoute =
  WorkspacesWorkspaceIdBotsBotIdEventsRouteImport.update({
    id: '/events',
    path: '/events',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)
const WorkspacesWorkspaceIdBotsBotIdConversationsRoute =
  WorkspacesWorkspaceIdBotsBotIdConversationsRouteImport.update({
    id: '/conversations',
    path: '/conversations',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)
const WorkspacesWorkspaceIdBotsBotIdAnalyticsRoute =
  WorkspacesWorkspaceIdBotsBotIdAnalyticsRouteImport.update({
    id: '/analytics',
    path: '/analytics',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)
const WorkspacesWorkspaceIdBotsBotIdSplatRoute =
  WorkspacesWorkspaceIdBotsBotIdSplatRouteImport.update({
    id: '/$',
    path: '/$',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)
const WorkspacesWorkspaceIdBotsBotIdWebchatIndexRoute =
  WorkspacesWorkspaceIdBotsBotIdWebchatIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdWebchatRoute,
  } as any)
const WorkspacesWorkspaceIdBotsBotIdTablesIndexRoute =
  WorkspacesWorkspaceIdBotsBotIdTablesIndexRouteImport.update({
    id: '/tables/',
    path: '/tables/',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)
const WorkspacesWorkspaceIdBotsBotIdSettingsIndexRoute =
  WorkspacesWorkspaceIdBotsBotIdSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdSettingsRoute,
  } as any)
const WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesIndexRoute =
  WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesIndexRouteImport.update({
    id: '/knowledge-bases/',
    path: '/knowledge-bases/',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)
const WorkspacesWorkspaceIdBotsBotIdIssuesIndexRoute =
  WorkspacesWorkspaceIdBotsBotIdIssuesIndexRouteImport.update({
    id: '/issues/',
    path: '/issues/',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)
const WorkspacesWorkspaceIdBotsBotIdTablesTableIdRoute =
  WorkspacesWorkspaceIdBotsBotIdTablesTableIdRouteImport.update({
    id: '/tables/$tableId',
    path: '/tables/$tableId',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)
const WorkspacesWorkspaceIdBotsBotIdSettingsGeneralRoute =
  WorkspacesWorkspaceIdBotsBotIdSettingsGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdSettingsRoute,
  } as any)
const WorkspacesWorkspaceIdBotsBotIdSettingsAccessControlRoute =
  WorkspacesWorkspaceIdBotsBotIdSettingsAccessControlRouteImport.update({
    id: '/access-control',
    path: '/access-control',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdSettingsRoute,
  } as any)
const WorkspacesWorkspaceIdBotsBotIdIssuesIssueIdRoute =
  WorkspacesWorkspaceIdBotsBotIdIssuesIssueIdRouteImport.update({
    id: '/issues/$issueId',
    path: '/issues/$issueId',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)
const WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdRoute =
  WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdRouteImport.update({
    id: '/$conversationId',
    path: '/$conversationId',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdConversationsRoute,
  } as any)
const WorkspacesWorkspaceIdBotsBotIdConversationIdQueryMessageIdRoute =
  WorkspacesWorkspaceIdBotsBotIdConversationIdQueryMessageIdRouteImport.update({
    id: '/conversationIdQuery/$messageId',
    path: '/conversationIdQuery/$messageId',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)
const WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesKbIdIndexRoute =
  WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesKbIdIndexRouteImport.update({
    id: '/knowledge-bases/$kbId/',
    path: '/knowledge-bases/$kbId/',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)
const WorkspacesWorkspaceIdBotsBotIdWebchatV2ShareRoute =
  WorkspacesWorkspaceIdBotsBotIdWebchatV2ShareRouteImport.update({
    id: '/v2/share',
    path: '/v2/share',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdWebchatRoute,
  } as any)
const WorkspacesWorkspaceIdBotsBotIdWebchatV2IdentityRoute =
  WorkspacesWorkspaceIdBotsBotIdWebchatV2IdentityRouteImport.update({
    id: '/v2/identity',
    path: '/v2/identity',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdWebchatRoute,
  } as any)
const WorkspacesWorkspaceIdBotsBotIdWebchatV2GeneralRoute =
  WorkspacesWorkspaceIdBotsBotIdWebchatV2GeneralRouteImport.update({
    id: '/v2/general',
    path: '/v2/general',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdWebchatRoute,
  } as any)
const WorkspacesWorkspaceIdBotsBotIdWebchatV2FeaturesRoute =
  WorkspacesWorkspaceIdBotsBotIdWebchatV2FeaturesRouteImport.update({
    id: '/v2/features',
    path: '/v2/features',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdWebchatRoute,
  } as any)
const WorkspacesWorkspaceIdBotsBotIdWebchatV2DeploySettingsRoute =
  WorkspacesWorkspaceIdBotsBotIdWebchatV2DeploySettingsRouteImport.update({
    id: '/v2/deploy-settings',
    path: '/v2/deploy-settings',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdWebchatRoute,
  } as any)
const WorkspacesWorkspaceIdBotsBotIdWebchatV2AppearanceRoute =
  WorkspacesWorkspaceIdBotsBotIdWebchatV2AppearanceRouteImport.update({
    id: '/v2/appearance',
    path: '/v2/appearance',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdWebchatRoute,
  } as any)
const WorkspacesWorkspaceIdBotsBotIdWebchatV2AdvancedSettingsRoute =
  WorkspacesWorkspaceIdBotsBotIdWebchatV2AdvancedSettingsRouteImport.update({
    id: '/v2/advanced-settings',
    path: '/v2/advanced-settings',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdWebchatRoute,
  } as any)
const WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesKbIdDsIdRoute =
  WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesKbIdDsIdRouteImport.update({
    id: '/knowledge-bases/$kbId/$dsId',
    path: '/knowledge-bases/$kbId/$dsId',
    getParentRoute: () => WorkspacesWorkspaceIdBotsBotIdRoute,
  } as any)
const WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdMessagesMessageIdRoute =
  WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdMessagesMessageIdRouteImport.update(
    {
      id: '/messages/$messageId',
      path: '/messages/$messageId',
      getParentRoute: () =>
        WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/checkout': typeof CheckoutRoute
  '/cli-login': typeof CliLoginRoute
  '/forbidden': typeof ForbiddenRoute
  '/welcome': typeof WelcomeRoute
  '/oauth/interstitial': typeof OauthInterstitialRoute
  '/profile/account': typeof ProfileAccountRoute
  '/profile/settings': typeof ProfileSettingsRoute
  '/workspaces/$workspaceId': typeof WorkspacesWorkspaceIdRouteWithChildren
  '/workspaces': typeof WorkspacesIndexRoute
  '/workspaces/$workspaceId/$': typeof WorkspacesWorkspaceIdSplatRoute
  '/workspaces/$workspaceId/billing': typeof WorkspacesWorkspaceIdBillingRoute
  '/workspaces/$workspaceId/bots': typeof WorkspacesWorkspaceIdBotsRoute
  '/workspaces/$workspaceId/chatbots': typeof WorkspacesWorkspaceIdChatbotsRoute
  '/workspaces/$workspaceId/checkout-trigger': typeof WorkspacesWorkspaceIdCheckoutTriggerRoute
  '/workspaces/$workspaceId/create-bot': typeof WorkspacesWorkspaceIdCreateBotRoute
  '/workspaces/$workspaceId/home': typeof WorkspacesWorkspaceIdHomeRoute
  '/workspaces/$workspaceId/loading-bot': typeof WorkspacesWorkspaceIdLoadingBotRoute
  '/workspaces/$workspaceId/onboarding': typeof WorkspacesWorkspaceIdOnboardingRoute
  '/workspaces/$workspaceId/profile': typeof WorkspacesWorkspaceIdProfileRouteWithChildren
  '/workspaces/$workspaceId/settings': typeof WorkspacesWorkspaceIdSettingsRouteWithChildren
  '/workspaces/$workspaceId/usage': typeof WorkspacesWorkspaceIdUsageRouteWithChildren
  '/workspaces/$workspaceId/': typeof WorkspacesWorkspaceIdIndexRoute
  '/workspaces/$workspaceId/bots/$botId': typeof WorkspacesWorkspaceIdBotsBotIdRouteWithChildren
  '/workspaces/$workspaceId/chatbots/$botId': typeof WorkspacesWorkspaceIdChatbotsBotIdRouteWithChildren
  '/workspaces/$workspaceId/integrations/$integrationId': typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdRouteWithChildren
  '/workspaces/$workspaceId/profile/account': typeof WorkspacesWorkspaceIdProfileAccountRoute
  '/workspaces/$workspaceId/profile/settings': typeof WorkspacesWorkspaceIdProfileSettingsRoute
  '/workspaces/$workspaceId/settings/$': typeof WorkspacesWorkspaceIdSettingsSplatRoute
  '/workspaces/$workspaceId/settings/audits': typeof WorkspacesWorkspaceIdSettingsAuditsRoute
  '/workspaces/$workspaceId/settings/details': typeof WorkspacesWorkspaceIdSettingsDetailsRoute
  '/workspaces/$workspaceId/settings/members': typeof WorkspacesWorkspaceIdSettingsMembersRoute
  '/workspaces/$workspaceId/usage/ai-spend': typeof WorkspacesWorkspaceIdUsageAiSpendRoute
  '/workspaces/$workspaceId/usage/monthly-summary': typeof WorkspacesWorkspaceIdUsageMonthlySummaryRoute
  '/workspaces/$workspaceId/integrations': typeof WorkspacesWorkspaceIdIntegrationsIndexRoute
  '/workspaces/$workspaceId/settings/': typeof WorkspacesWorkspaceIdSettingsIndexRoute
  '/workspaces/$workspaceId/usage/': typeof WorkspacesWorkspaceIdUsageIndexRoute
  '/workspaces/$workspaceId/bots/$botId/$': typeof WorkspacesWorkspaceIdBotsBotIdSplatRoute
  '/workspaces/$workspaceId/bots/$botId/analytics': typeof WorkspacesWorkspaceIdBotsBotIdAnalyticsRoute
  '/workspaces/$workspaceId/bots/$botId/conversations': typeof WorkspacesWorkspaceIdBotsBotIdConversationsRouteWithChildren
  '/workspaces/$workspaceId/bots/$botId/events': typeof WorkspacesWorkspaceIdBotsBotIdEventsRoute
  '/workspaces/$workspaceId/bots/$botId/files': typeof WorkspacesWorkspaceIdBotsBotIdFilesRoute
  '/workspaces/$workspaceId/bots/$botId/hitl': typeof WorkspacesWorkspaceIdBotsBotIdHitlRoute
  '/workspaces/$workspaceId/bots/$botId/integrations': typeof WorkspacesWorkspaceIdBotsBotIdIntegrationsRoute
  '/workspaces/$workspaceId/bots/$botId/logs': typeof WorkspacesWorkspaceIdBotsBotIdLogsRoute
  '/workspaces/$workspaceId/bots/$botId/new-adk-bot-setup': typeof WorkspacesWorkspaceIdBotsBotIdNewAdkBotSetupRoute
  '/workspaces/$workspaceId/bots/$botId/new-bot': typeof WorkspacesWorkspaceIdBotsBotIdNewBotRoute
  '/workspaces/$workspaceId/bots/$botId/new-chat': typeof WorkspacesWorkspaceIdBotsBotIdNewChatRoute
  '/workspaces/$workspaceId/bots/$botId/overview': typeof WorkspacesWorkspaceIdBotsBotIdOverviewRoute
  '/workspaces/$workspaceId/bots/$botId/settings': typeof WorkspacesWorkspaceIdBotsBotIdSettingsRouteWithChildren
  '/workspaces/$workspaceId/bots/$botId/users': typeof WorkspacesWorkspaceIdBotsBotIdUsersRoute
  '/workspaces/$workspaceId/bots/$botId/vibe': typeof WorkspacesWorkspaceIdBotsBotIdVibeRoute
  '/workspaces/$workspaceId/bots/$botId/webchat': typeof WorkspacesWorkspaceIdBotsBotIdWebchatRouteWithChildren
  '/workspaces/$workspaceId/bots/$botId/workflows': typeof WorkspacesWorkspaceIdBotsBotIdWorkflowsRoute
  '/workspaces/$workspaceId/chatbots/$botId/$': typeof WorkspacesWorkspaceIdChatbotsBotIdSplatRoute
  '/workspaces/$workspaceId/integrations/$integrationId/$': typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdSplatRoute
  '/workspaces/$workspaceId/integrations/$integrationId/logs': typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdLogsRoute
  '/workspaces/$workspaceId/integrations/$integrationId/settings': typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdSettingsRoute
  '/workspaces/$workspaceId/integrations/$integrationId/versions': typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdVersionsRoute
  '/workspaces/$workspaceId/bots/$botId/': typeof WorkspacesWorkspaceIdBotsBotIdIndexRoute
  '/workspaces/$workspaceId/integrations/$integrationId/': typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdIndexRoute
  '/workspaces/$workspaceId/bots/$botId/conversationIdQuery/$messageId': typeof WorkspacesWorkspaceIdBotsBotIdConversationIdQueryMessageIdRoute
  '/workspaces/$workspaceId/bots/$botId/conversations/$conversationId': typeof WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdRouteWithChildren
  '/workspaces/$workspaceId/bots/$botId/issues/$issueId': typeof WorkspacesWorkspaceIdBotsBotIdIssuesIssueIdRoute
  '/workspaces/$workspaceId/bots/$botId/settings/access-control': typeof WorkspacesWorkspaceIdBotsBotIdSettingsAccessControlRoute
  '/workspaces/$workspaceId/bots/$botId/settings/general': typeof WorkspacesWorkspaceIdBotsBotIdSettingsGeneralRoute
  '/workspaces/$workspaceId/bots/$botId/tables/$tableId': typeof WorkspacesWorkspaceIdBotsBotIdTablesTableIdRoute
  '/workspaces/$workspaceId/bots/$botId/issues': typeof WorkspacesWorkspaceIdBotsBotIdIssuesIndexRoute
  '/workspaces/$workspaceId/bots/$botId/knowledge-bases': typeof WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesIndexRoute
  '/workspaces/$workspaceId/bots/$botId/settings/': typeof WorkspacesWorkspaceIdBotsBotIdSettingsIndexRoute
  '/workspaces/$workspaceId/bots/$botId/tables': typeof WorkspacesWorkspaceIdBotsBotIdTablesIndexRoute
  '/workspaces/$workspaceId/bots/$botId/webchat/': typeof WorkspacesWorkspaceIdBotsBotIdWebchatIndexRoute
  '/workspaces/$workspaceId/bots/$botId/knowledge-bases/$kbId/$dsId': typeof WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesKbIdDsIdRoute
  '/workspaces/$workspaceId/bots/$botId/webchat/v2/advanced-settings': typeof WorkspacesWorkspaceIdBotsBotIdWebchatV2AdvancedSettingsRoute
  '/workspaces/$workspaceId/bots/$botId/webchat/v2/appearance': typeof WorkspacesWorkspaceIdBotsBotIdWebchatV2AppearanceRoute
  '/workspaces/$workspaceId/bots/$botId/webchat/v2/deploy-settings': typeof WorkspacesWorkspaceIdBotsBotIdWebchatV2DeploySettingsRoute
  '/workspaces/$workspaceId/bots/$botId/webchat/v2/features': typeof WorkspacesWorkspaceIdBotsBotIdWebchatV2FeaturesRoute
  '/workspaces/$workspaceId/bots/$botId/webchat/v2/general': typeof WorkspacesWorkspaceIdBotsBotIdWebchatV2GeneralRoute
  '/workspaces/$workspaceId/bots/$botId/webchat/v2/identity': typeof WorkspacesWorkspaceIdBotsBotIdWebchatV2IdentityRoute
  '/workspaces/$workspaceId/bots/$botId/webchat/v2/share': typeof WorkspacesWorkspaceIdBotsBotIdWebchatV2ShareRoute
  '/workspaces/$workspaceId/bots/$botId/knowledge-bases/$kbId': typeof WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesKbIdIndexRoute
  '/workspaces/$workspaceId/bots/$botId/conversations/$conversationId/messages/$messageId': typeof WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdMessagesMessageIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/checkout': typeof CheckoutRoute
  '/cli-login': typeof CliLoginRoute
  '/forbidden': typeof ForbiddenRoute
  '/welcome': typeof WelcomeRoute
  '/oauth/interstitial': typeof OauthInterstitialRoute
  '/profile/account': typeof ProfileAccountRoute
  '/profile/settings': typeof ProfileSettingsRoute
  '/workspaces': typeof WorkspacesIndexRoute
  '/workspaces/$workspaceId/$': typeof WorkspacesWorkspaceIdSplatRoute
  '/workspaces/$workspaceId/billing': typeof WorkspacesWorkspaceIdBillingRoute
  '/workspaces/$workspaceId/bots': typeof WorkspacesWorkspaceIdBotsRoute
  '/workspaces/$workspaceId/chatbots': typeof WorkspacesWorkspaceIdChatbotsRoute
  '/workspaces/$workspaceId/checkout-trigger': typeof WorkspacesWorkspaceIdCheckoutTriggerRoute
  '/workspaces/$workspaceId/create-bot': typeof WorkspacesWorkspaceIdCreateBotRoute
  '/workspaces/$workspaceId/home': typeof WorkspacesWorkspaceIdHomeRoute
  '/workspaces/$workspaceId/loading-bot': typeof WorkspacesWorkspaceIdLoadingBotRoute
  '/workspaces/$workspaceId/onboarding': typeof WorkspacesWorkspaceIdOnboardingRoute
  '/workspaces/$workspaceId/profile': typeof WorkspacesWorkspaceIdProfileRouteWithChildren
  '/workspaces/$workspaceId': typeof WorkspacesWorkspaceIdIndexRoute
  '/workspaces/$workspaceId/chatbots/$botId': typeof WorkspacesWorkspaceIdChatbotsBotIdRouteWithChildren
  '/workspaces/$workspaceId/profile/account': typeof WorkspacesWorkspaceIdProfileAccountRoute
  '/workspaces/$workspaceId/profile/settings': typeof WorkspacesWorkspaceIdProfileSettingsRoute
  '/workspaces/$workspaceId/settings/$': typeof WorkspacesWorkspaceIdSettingsSplatRoute
  '/workspaces/$workspaceId/settings/audits': typeof WorkspacesWorkspaceIdSettingsAuditsRoute
  '/workspaces/$workspaceId/settings/details': typeof WorkspacesWorkspaceIdSettingsDetailsRoute
  '/workspaces/$workspaceId/settings/members': typeof WorkspacesWorkspaceIdSettingsMembersRoute
  '/workspaces/$workspaceId/usage/ai-spend': typeof WorkspacesWorkspaceIdUsageAiSpendRoute
  '/workspaces/$workspaceId/usage/monthly-summary': typeof WorkspacesWorkspaceIdUsageMonthlySummaryRoute
  '/workspaces/$workspaceId/integrations': typeof WorkspacesWorkspaceIdIntegrationsIndexRoute
  '/workspaces/$workspaceId/settings': typeof WorkspacesWorkspaceIdSettingsIndexRoute
  '/workspaces/$workspaceId/usage': typeof WorkspacesWorkspaceIdUsageIndexRoute
  '/workspaces/$workspaceId/bots/$botId/$': typeof WorkspacesWorkspaceIdBotsBotIdSplatRoute
  '/workspaces/$workspaceId/bots/$botId/analytics': typeof WorkspacesWorkspaceIdBotsBotIdAnalyticsRoute
  '/workspaces/$workspaceId/bots/$botId/conversations': typeof WorkspacesWorkspaceIdBotsBotIdConversationsRouteWithChildren
  '/workspaces/$workspaceId/bots/$botId/events': typeof WorkspacesWorkspaceIdBotsBotIdEventsRoute
  '/workspaces/$workspaceId/bots/$botId/files': typeof WorkspacesWorkspaceIdBotsBotIdFilesRoute
  '/workspaces/$workspaceId/bots/$botId/hitl': typeof WorkspacesWorkspaceIdBotsBotIdHitlRoute
  '/workspaces/$workspaceId/bots/$botId/integrations': typeof WorkspacesWorkspaceIdBotsBotIdIntegrationsRoute
  '/workspaces/$workspaceId/bots/$botId/logs': typeof WorkspacesWorkspaceIdBotsBotIdLogsRoute
  '/workspaces/$workspaceId/bots/$botId/new-adk-bot-setup': typeof WorkspacesWorkspaceIdBotsBotIdNewAdkBotSetupRoute
  '/workspaces/$workspaceId/bots/$botId/new-bot': typeof WorkspacesWorkspaceIdBotsBotIdNewBotRoute
  '/workspaces/$workspaceId/bots/$botId/new-chat': typeof WorkspacesWorkspaceIdBotsBotIdNewChatRoute
  '/workspaces/$workspaceId/bots/$botId/overview': typeof WorkspacesWorkspaceIdBotsBotIdOverviewRoute
  '/workspaces/$workspaceId/bots/$botId/users': typeof WorkspacesWorkspaceIdBotsBotIdUsersRoute
  '/workspaces/$workspaceId/bots/$botId/vibe': typeof WorkspacesWorkspaceIdBotsBotIdVibeRoute
  '/workspaces/$workspaceId/bots/$botId/workflows': typeof WorkspacesWorkspaceIdBotsBotIdWorkflowsRoute
  '/workspaces/$workspaceId/chatbots/$botId/$': typeof WorkspacesWorkspaceIdChatbotsBotIdSplatRoute
  '/workspaces/$workspaceId/integrations/$integrationId/$': typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdSplatRoute
  '/workspaces/$workspaceId/integrations/$integrationId/logs': typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdLogsRoute
  '/workspaces/$workspaceId/integrations/$integrationId/settings': typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdSettingsRoute
  '/workspaces/$workspaceId/integrations/$integrationId/versions': typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdVersionsRoute
  '/workspaces/$workspaceId/bots/$botId': typeof WorkspacesWorkspaceIdBotsBotIdIndexRoute
  '/workspaces/$workspaceId/integrations/$integrationId': typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdIndexRoute
  '/workspaces/$workspaceId/bots/$botId/conversationIdQuery/$messageId': typeof WorkspacesWorkspaceIdBotsBotIdConversationIdQueryMessageIdRoute
  '/workspaces/$workspaceId/bots/$botId/conversations/$conversationId': typeof WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdRouteWithChildren
  '/workspaces/$workspaceId/bots/$botId/issues/$issueId': typeof WorkspacesWorkspaceIdBotsBotIdIssuesIssueIdRoute
  '/workspaces/$workspaceId/bots/$botId/settings/access-control': typeof WorkspacesWorkspaceIdBotsBotIdSettingsAccessControlRoute
  '/workspaces/$workspaceId/bots/$botId/settings/general': typeof WorkspacesWorkspaceIdBotsBotIdSettingsGeneralRoute
  '/workspaces/$workspaceId/bots/$botId/tables/$tableId': typeof WorkspacesWorkspaceIdBotsBotIdTablesTableIdRoute
  '/workspaces/$workspaceId/bots/$botId/issues': typeof WorkspacesWorkspaceIdBotsBotIdIssuesIndexRoute
  '/workspaces/$workspaceId/bots/$botId/knowledge-bases': typeof WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesIndexRoute
  '/workspaces/$workspaceId/bots/$botId/settings': typeof WorkspacesWorkspaceIdBotsBotIdSettingsIndexRoute
  '/workspaces/$workspaceId/bots/$botId/tables': typeof WorkspacesWorkspaceIdBotsBotIdTablesIndexRoute
  '/workspaces/$workspaceId/bots/$botId/webchat': typeof WorkspacesWorkspaceIdBotsBotIdWebchatIndexRoute
  '/workspaces/$workspaceId/bots/$botId/knowledge-bases/$kbId/$dsId': typeof WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesKbIdDsIdRoute
  '/workspaces/$workspaceId/bots/$botId/webchat/v2/advanced-settings': typeof WorkspacesWorkspaceIdBotsBotIdWebchatV2AdvancedSettingsRoute
  '/workspaces/$workspaceId/bots/$botId/webchat/v2/appearance': typeof WorkspacesWorkspaceIdBotsBotIdWebchatV2AppearanceRoute
  '/workspaces/$workspaceId/bots/$botId/webchat/v2/deploy-settings': typeof WorkspacesWorkspaceIdBotsBotIdWebchatV2DeploySettingsRoute
  '/workspaces/$workspaceId/bots/$botId/webchat/v2/features': typeof WorkspacesWorkspaceIdBotsBotIdWebchatV2FeaturesRoute
  '/workspaces/$workspaceId/bots/$botId/webchat/v2/general': typeof WorkspacesWorkspaceIdBotsBotIdWebchatV2GeneralRoute
  '/workspaces/$workspaceId/bots/$botId/webchat/v2/identity': typeof WorkspacesWorkspaceIdBotsBotIdWebchatV2IdentityRoute
  '/workspaces/$workspaceId/bots/$botId/webchat/v2/share': typeof WorkspacesWorkspaceIdBotsBotIdWebchatV2ShareRoute
  '/workspaces/$workspaceId/bots/$botId/knowledge-bases/$kbId': typeof WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesKbIdIndexRoute
  '/workspaces/$workspaceId/bots/$botId/conversations/$conversationId/messages/$messageId': typeof WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdMessagesMessageIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/checkout': typeof CheckoutRoute
  '/cli-login': typeof CliLoginRoute
  '/forbidden': typeof ForbiddenRoute
  '/welcome': typeof WelcomeRoute
  '/oauth/interstitial': typeof OauthInterstitialRoute
  '/profile/account': typeof ProfileAccountRoute
  '/profile/settings': typeof ProfileSettingsRoute
  '/workspaces/$workspaceId': typeof WorkspacesWorkspaceIdRouteWithChildren
  '/workspaces/': typeof WorkspacesIndexRoute
  '/workspaces/$workspaceId/$': typeof WorkspacesWorkspaceIdSplatRoute
  '/workspaces/$workspaceId/billing': typeof WorkspacesWorkspaceIdBillingRoute
  '/workspaces/$workspaceId/bots_': typeof WorkspacesWorkspaceIdBotsRoute
  '/workspaces/$workspaceId/chatbots_': typeof WorkspacesWorkspaceIdChatbotsRoute
  '/workspaces/$workspaceId/checkout-trigger': typeof WorkspacesWorkspaceIdCheckoutTriggerRoute
  '/workspaces/$workspaceId/create-bot': typeof WorkspacesWorkspaceIdCreateBotRoute
  '/workspaces/$workspaceId/home': typeof WorkspacesWorkspaceIdHomeRoute
  '/workspaces/$workspaceId/loading-bot': typeof WorkspacesWorkspaceIdLoadingBotRoute
  '/workspaces/$workspaceId/onboarding': typeof WorkspacesWorkspaceIdOnboardingRoute
  '/workspaces/$workspaceId/profile': typeof WorkspacesWorkspaceIdProfileRouteWithChildren
  '/workspaces/$workspaceId/settings': typeof WorkspacesWorkspaceIdSettingsRouteWithChildren
  '/workspaces/$workspaceId/usage': typeof WorkspacesWorkspaceIdUsageRouteWithChildren
  '/workspaces/$workspaceId/': typeof WorkspacesWorkspaceIdIndexRoute
  '/workspaces/$workspaceId/bots/$botId': typeof WorkspacesWorkspaceIdBotsBotIdRouteWithChildren
  '/workspaces/$workspaceId/chatbots/$botId': typeof WorkspacesWorkspaceIdChatbotsBotIdRouteWithChildren
  '/workspaces/$workspaceId/integrations/$integrationId': typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdRouteWithChildren
  '/workspaces/$workspaceId/profile/account': typeof WorkspacesWorkspaceIdProfileAccountRoute
  '/workspaces/$workspaceId/profile/settings': typeof WorkspacesWorkspaceIdProfileSettingsRoute
  '/workspaces/$workspaceId/settings/$': typeof WorkspacesWorkspaceIdSettingsSplatRoute
  '/workspaces/$workspaceId/settings/audits': typeof WorkspacesWorkspaceIdSettingsAuditsRoute
  '/workspaces/$workspaceId/settings/details': typeof WorkspacesWorkspaceIdSettingsDetailsRoute
  '/workspaces/$workspaceId/settings/members': typeof WorkspacesWorkspaceIdSettingsMembersRoute
  '/workspaces/$workspaceId/usage/ai-spend': typeof WorkspacesWorkspaceIdUsageAiSpendRoute
  '/workspaces/$workspaceId/usage/monthly-summary': typeof WorkspacesWorkspaceIdUsageMonthlySummaryRoute
  '/workspaces/$workspaceId/integrations/': typeof WorkspacesWorkspaceIdIntegrationsIndexRoute
  '/workspaces/$workspaceId/settings/': typeof WorkspacesWorkspaceIdSettingsIndexRoute
  '/workspaces/$workspaceId/usage/': typeof WorkspacesWorkspaceIdUsageIndexRoute
  '/workspaces/$workspaceId/bots/$botId/$': typeof WorkspacesWorkspaceIdBotsBotIdSplatRoute
  '/workspaces/$workspaceId/bots/$botId/analytics': typeof WorkspacesWorkspaceIdBotsBotIdAnalyticsRoute
  '/workspaces/$workspaceId/bots/$botId/conversations': typeof WorkspacesWorkspaceIdBotsBotIdConversationsRouteWithChildren
  '/workspaces/$workspaceId/bots/$botId/events': typeof WorkspacesWorkspaceIdBotsBotIdEventsRoute
  '/workspaces/$workspaceId/bots/$botId/files': typeof WorkspacesWorkspaceIdBotsBotIdFilesRoute
  '/workspaces/$workspaceId/bots/$botId/hitl': typeof WorkspacesWorkspaceIdBotsBotIdHitlRoute
  '/workspaces/$workspaceId/bots/$botId/integrations': typeof WorkspacesWorkspaceIdBotsBotIdIntegrationsRoute
  '/workspaces/$workspaceId/bots/$botId/logs': typeof WorkspacesWorkspaceIdBotsBotIdLogsRoute
  '/workspaces/$workspaceId/bots/$botId/new-adk-bot-setup': typeof WorkspacesWorkspaceIdBotsBotIdNewAdkBotSetupRoute
  '/workspaces/$workspaceId/bots/$botId/new-bot': typeof WorkspacesWorkspaceIdBotsBotIdNewBotRoute
  '/workspaces/$workspaceId/bots/$botId/new-chat': typeof WorkspacesWorkspaceIdBotsBotIdNewChatRoute
  '/workspaces/$workspaceId/bots/$botId/overview': typeof WorkspacesWorkspaceIdBotsBotIdOverviewRoute
  '/workspaces/$workspaceId/bots/$botId/settings': typeof WorkspacesWorkspaceIdBotsBotIdSettingsRouteWithChildren
  '/workspaces/$workspaceId/bots/$botId/users': typeof WorkspacesWorkspaceIdBotsBotIdUsersRoute
  '/workspaces/$workspaceId/bots/$botId/vibe': typeof WorkspacesWorkspaceIdBotsBotIdVibeRoute
  '/workspaces/$workspaceId/bots/$botId/webchat': typeof WorkspacesWorkspaceIdBotsBotIdWebchatRouteWithChildren
  '/workspaces/$workspaceId/bots/$botId/workflows': typeof WorkspacesWorkspaceIdBotsBotIdWorkflowsRoute
  '/workspaces/$workspaceId/chatbots/$botId/$': typeof WorkspacesWorkspaceIdChatbotsBotIdSplatRoute
  '/workspaces/$workspaceId/integrations/$integrationId/$': typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdSplatRoute
  '/workspaces/$workspaceId/integrations/$integrationId/logs': typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdLogsRoute
  '/workspaces/$workspaceId/integrations/$integrationId/settings': typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdSettingsRoute
  '/workspaces/$workspaceId/integrations/$integrationId/versions': typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdVersionsRoute
  '/workspaces/$workspaceId/bots/$botId/': typeof WorkspacesWorkspaceIdBotsBotIdIndexRoute
  '/workspaces/$workspaceId/integrations/$integrationId/': typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdIndexRoute
  '/workspaces/$workspaceId/bots/$botId/conversationIdQuery/$messageId': typeof WorkspacesWorkspaceIdBotsBotIdConversationIdQueryMessageIdRoute
  '/workspaces/$workspaceId/bots/$botId/conversations/$conversationId': typeof WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdRouteWithChildren
  '/workspaces/$workspaceId/bots/$botId/issues/$issueId': typeof WorkspacesWorkspaceIdBotsBotIdIssuesIssueIdRoute
  '/workspaces/$workspaceId/bots/$botId/settings/access-control': typeof WorkspacesWorkspaceIdBotsBotIdSettingsAccessControlRoute
  '/workspaces/$workspaceId/bots/$botId/settings/general': typeof WorkspacesWorkspaceIdBotsBotIdSettingsGeneralRoute
  '/workspaces/$workspaceId/bots/$botId/tables/$tableId': typeof WorkspacesWorkspaceIdBotsBotIdTablesTableIdRoute
  '/workspaces/$workspaceId/bots/$botId/issues/': typeof WorkspacesWorkspaceIdBotsBotIdIssuesIndexRoute
  '/workspaces/$workspaceId/bots/$botId/knowledge-bases/': typeof WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesIndexRoute
  '/workspaces/$workspaceId/bots/$botId/settings/': typeof WorkspacesWorkspaceIdBotsBotIdSettingsIndexRoute
  '/workspaces/$workspaceId/bots/$botId/tables/': typeof WorkspacesWorkspaceIdBotsBotIdTablesIndexRoute
  '/workspaces/$workspaceId/bots/$botId/webchat/': typeof WorkspacesWorkspaceIdBotsBotIdWebchatIndexRoute
  '/workspaces/$workspaceId/bots/$botId/knowledge-bases/$kbId/$dsId': typeof WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesKbIdDsIdRoute
  '/workspaces/$workspaceId/bots/$botId/webchat/v2/advanced-settings': typeof WorkspacesWorkspaceIdBotsBotIdWebchatV2AdvancedSettingsRoute
  '/workspaces/$workspaceId/bots/$botId/webchat/v2/appearance': typeof WorkspacesWorkspaceIdBotsBotIdWebchatV2AppearanceRoute
  '/workspaces/$workspaceId/bots/$botId/webchat/v2/deploy-settings': typeof WorkspacesWorkspaceIdBotsBotIdWebchatV2DeploySettingsRoute
  '/workspaces/$workspaceId/bots/$botId/webchat/v2/features': typeof WorkspacesWorkspaceIdBotsBotIdWebchatV2FeaturesRoute
  '/workspaces/$workspaceId/bots/$botId/webchat/v2/general': typeof WorkspacesWorkspaceIdBotsBotIdWebchatV2GeneralRoute
  '/workspaces/$workspaceId/bots/$botId/webchat/v2/identity': typeof WorkspacesWorkspaceIdBotsBotIdWebchatV2IdentityRoute
  '/workspaces/$workspaceId/bots/$botId/webchat/v2/share': typeof WorkspacesWorkspaceIdBotsBotIdWebchatV2ShareRoute
  '/workspaces/$workspaceId/bots/$botId/knowledge-bases/$kbId/': typeof WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesKbIdIndexRoute
  '/workspaces/$workspaceId/bots/$botId/conversations/$conversationId/messages/$messageId': typeof WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdMessagesMessageIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$'
    | '/checkout'
    | '/cli-login'
    | '/forbidden'
    | '/welcome'
    | '/oauth/interstitial'
    | '/profile/account'
    | '/profile/settings'
    | '/workspaces/$workspaceId'
    | '/workspaces'
    | '/workspaces/$workspaceId/$'
    | '/workspaces/$workspaceId/billing'
    | '/workspaces/$workspaceId/bots'
    | '/workspaces/$workspaceId/chatbots'
    | '/workspaces/$workspaceId/checkout-trigger'
    | '/workspaces/$workspaceId/create-bot'
    | '/workspaces/$workspaceId/home'
    | '/workspaces/$workspaceId/loading-bot'
    | '/workspaces/$workspaceId/onboarding'
    | '/workspaces/$workspaceId/profile'
    | '/workspaces/$workspaceId/settings'
    | '/workspaces/$workspaceId/usage'
    | '/workspaces/$workspaceId/'
    | '/workspaces/$workspaceId/bots/$botId'
    | '/workspaces/$workspaceId/chatbots/$botId'
    | '/workspaces/$workspaceId/integrations/$integrationId'
    | '/workspaces/$workspaceId/profile/account'
    | '/workspaces/$workspaceId/profile/settings'
    | '/workspaces/$workspaceId/settings/$'
    | '/workspaces/$workspaceId/settings/audits'
    | '/workspaces/$workspaceId/settings/details'
    | '/workspaces/$workspaceId/settings/members'
    | '/workspaces/$workspaceId/usage/ai-spend'
    | '/workspaces/$workspaceId/usage/monthly-summary'
    | '/workspaces/$workspaceId/integrations'
    | '/workspaces/$workspaceId/settings/'
    | '/workspaces/$workspaceId/usage/'
    | '/workspaces/$workspaceId/bots/$botId/$'
    | '/workspaces/$workspaceId/bots/$botId/analytics'
    | '/workspaces/$workspaceId/bots/$botId/conversations'
    | '/workspaces/$workspaceId/bots/$botId/events'
    | '/workspaces/$workspaceId/bots/$botId/files'
    | '/workspaces/$workspaceId/bots/$botId/hitl'
    | '/workspaces/$workspaceId/bots/$botId/integrations'
    | '/workspaces/$workspaceId/bots/$botId/logs'
    | '/workspaces/$workspaceId/bots/$botId/new-adk-bot-setup'
    | '/workspaces/$workspaceId/bots/$botId/new-bot'
    | '/workspaces/$workspaceId/bots/$botId/new-chat'
    | '/workspaces/$workspaceId/bots/$botId/overview'
    | '/workspaces/$workspaceId/bots/$botId/settings'
    | '/workspaces/$workspaceId/bots/$botId/users'
    | '/workspaces/$workspaceId/bots/$botId/vibe'
    | '/workspaces/$workspaceId/bots/$botId/webchat'
    | '/workspaces/$workspaceId/bots/$botId/workflows'
    | '/workspaces/$workspaceId/chatbots/$botId/$'
    | '/workspaces/$workspaceId/integrations/$integrationId/$'
    | '/workspaces/$workspaceId/integrations/$integrationId/logs'
    | '/workspaces/$workspaceId/integrations/$integrationId/settings'
    | '/workspaces/$workspaceId/integrations/$integrationId/versions'
    | '/workspaces/$workspaceId/bots/$botId/'
    | '/workspaces/$workspaceId/integrations/$integrationId/'
    | '/workspaces/$workspaceId/bots/$botId/conversationIdQuery/$messageId'
    | '/workspaces/$workspaceId/bots/$botId/conversations/$conversationId'
    | '/workspaces/$workspaceId/bots/$botId/issues/$issueId'
    | '/workspaces/$workspaceId/bots/$botId/settings/access-control'
    | '/workspaces/$workspaceId/bots/$botId/settings/general'
    | '/workspaces/$workspaceId/bots/$botId/tables/$tableId'
    | '/workspaces/$workspaceId/bots/$botId/issues'
    | '/workspaces/$workspaceId/bots/$botId/knowledge-bases'
    | '/workspaces/$workspaceId/bots/$botId/settings/'
    | '/workspaces/$workspaceId/bots/$botId/tables'
    | '/workspaces/$workspaceId/bots/$botId/webchat/'
    | '/workspaces/$workspaceId/bots/$botId/knowledge-bases/$kbId/$dsId'
    | '/workspaces/$workspaceId/bots/$botId/webchat/v2/advanced-settings'
    | '/workspaces/$workspaceId/bots/$botId/webchat/v2/appearance'
    | '/workspaces/$workspaceId/bots/$botId/webchat/v2/deploy-settings'
    | '/workspaces/$workspaceId/bots/$botId/webchat/v2/features'
    | '/workspaces/$workspaceId/bots/$botId/webchat/v2/general'
    | '/workspaces/$workspaceId/bots/$botId/webchat/v2/identity'
    | '/workspaces/$workspaceId/bots/$botId/webchat/v2/share'
    | '/workspaces/$workspaceId/bots/$botId/knowledge-bases/$kbId'
    | '/workspaces/$workspaceId/bots/$botId/conversations/$conversationId/messages/$messageId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$'
    | '/checkout'
    | '/cli-login'
    | '/forbidden'
    | '/welcome'
    | '/oauth/interstitial'
    | '/profile/account'
    | '/profile/settings'
    | '/workspaces'
    | '/workspaces/$workspaceId/$'
    | '/workspaces/$workspaceId/billing'
    | '/workspaces/$workspaceId/bots'
    | '/workspaces/$workspaceId/chatbots'
    | '/workspaces/$workspaceId/checkout-trigger'
    | '/workspaces/$workspaceId/create-bot'
    | '/workspaces/$workspaceId/home'
    | '/workspaces/$workspaceId/loading-bot'
    | '/workspaces/$workspaceId/onboarding'
    | '/workspaces/$workspaceId/profile'
    | '/workspaces/$workspaceId'
    | '/workspaces/$workspaceId/chatbots/$botId'
    | '/workspaces/$workspaceId/profile/account'
    | '/workspaces/$workspaceId/profile/settings'
    | '/workspaces/$workspaceId/settings/$'
    | '/workspaces/$workspaceId/settings/audits'
    | '/workspaces/$workspaceId/settings/details'
    | '/workspaces/$workspaceId/settings/members'
    | '/workspaces/$workspaceId/usage/ai-spend'
    | '/workspaces/$workspaceId/usage/monthly-summary'
    | '/workspaces/$workspaceId/integrations'
    | '/workspaces/$workspaceId/settings'
    | '/workspaces/$workspaceId/usage'
    | '/workspaces/$workspaceId/bots/$botId/$'
    | '/workspaces/$workspaceId/bots/$botId/analytics'
    | '/workspaces/$workspaceId/bots/$botId/conversations'
    | '/workspaces/$workspaceId/bots/$botId/events'
    | '/workspaces/$workspaceId/bots/$botId/files'
    | '/workspaces/$workspaceId/bots/$botId/hitl'
    | '/workspaces/$workspaceId/bots/$botId/integrations'
    | '/workspaces/$workspaceId/bots/$botId/logs'
    | '/workspaces/$workspaceId/bots/$botId/new-adk-bot-setup'
    | '/workspaces/$workspaceId/bots/$botId/new-bot'
    | '/workspaces/$workspaceId/bots/$botId/new-chat'
    | '/workspaces/$workspaceId/bots/$botId/overview'
    | '/workspaces/$workspaceId/bots/$botId/users'
    | '/workspaces/$workspaceId/bots/$botId/vibe'
    | '/workspaces/$workspaceId/bots/$botId/workflows'
    | '/workspaces/$workspaceId/chatbots/$botId/$'
    | '/workspaces/$workspaceId/integrations/$integrationId/$'
    | '/workspaces/$workspaceId/integrations/$integrationId/logs'
    | '/workspaces/$workspaceId/integrations/$integrationId/settings'
    | '/workspaces/$workspaceId/integrations/$integrationId/versions'
    | '/workspaces/$workspaceId/bots/$botId'
    | '/workspaces/$workspaceId/integrations/$integrationId'
    | '/workspaces/$workspaceId/bots/$botId/conversationIdQuery/$messageId'
    | '/workspaces/$workspaceId/bots/$botId/conversations/$conversationId'
    | '/workspaces/$workspaceId/bots/$botId/issues/$issueId'
    | '/workspaces/$workspaceId/bots/$botId/settings/access-control'
    | '/workspaces/$workspaceId/bots/$botId/settings/general'
    | '/workspaces/$workspaceId/bots/$botId/tables/$tableId'
    | '/workspaces/$workspaceId/bots/$botId/issues'
    | '/workspaces/$workspaceId/bots/$botId/knowledge-bases'
    | '/workspaces/$workspaceId/bots/$botId/settings'
    | '/workspaces/$workspaceId/bots/$botId/tables'
    | '/workspaces/$workspaceId/bots/$botId/webchat'
    | '/workspaces/$workspaceId/bots/$botId/knowledge-bases/$kbId/$dsId'
    | '/workspaces/$workspaceId/bots/$botId/webchat/v2/advanced-settings'
    | '/workspaces/$workspaceId/bots/$botId/webchat/v2/appearance'
    | '/workspaces/$workspaceId/bots/$botId/webchat/v2/deploy-settings'
    | '/workspaces/$workspaceId/bots/$botId/webchat/v2/features'
    | '/workspaces/$workspaceId/bots/$botId/webchat/v2/general'
    | '/workspaces/$workspaceId/bots/$botId/webchat/v2/identity'
    | '/workspaces/$workspaceId/bots/$botId/webchat/v2/share'
    | '/workspaces/$workspaceId/bots/$botId/knowledge-bases/$kbId'
    | '/workspaces/$workspaceId/bots/$botId/conversations/$conversationId/messages/$messageId'
  id:
    | '__root__'
    | '/'
    | '/$'
    | '/checkout'
    | '/cli-login'
    | '/forbidden'
    | '/welcome'
    | '/oauth/interstitial'
    | '/profile/account'
    | '/profile/settings'
    | '/workspaces/$workspaceId'
    | '/workspaces/'
    | '/workspaces/$workspaceId/$'
    | '/workspaces/$workspaceId/billing'
    | '/workspaces/$workspaceId/bots_'
    | '/workspaces/$workspaceId/chatbots_'
    | '/workspaces/$workspaceId/checkout-trigger'
    | '/workspaces/$workspaceId/create-bot'
    | '/workspaces/$workspaceId/home'
    | '/workspaces/$workspaceId/loading-bot'
    | '/workspaces/$workspaceId/onboarding'
    | '/workspaces/$workspaceId/profile'
    | '/workspaces/$workspaceId/settings'
    | '/workspaces/$workspaceId/usage'
    | '/workspaces/$workspaceId/'
    | '/workspaces/$workspaceId/bots/$botId'
    | '/workspaces/$workspaceId/chatbots/$botId'
    | '/workspaces/$workspaceId/integrations/$integrationId'
    | '/workspaces/$workspaceId/profile/account'
    | '/workspaces/$workspaceId/profile/settings'
    | '/workspaces/$workspaceId/settings/$'
    | '/workspaces/$workspaceId/settings/audits'
    | '/workspaces/$workspaceId/settings/details'
    | '/workspaces/$workspaceId/settings/members'
    | '/workspaces/$workspaceId/usage/ai-spend'
    | '/workspaces/$workspaceId/usage/monthly-summary'
    | '/workspaces/$workspaceId/integrations/'
    | '/workspaces/$workspaceId/settings/'
    | '/workspaces/$workspaceId/usage/'
    | '/workspaces/$workspaceId/bots/$botId/$'
    | '/workspaces/$workspaceId/bots/$botId/analytics'
    | '/workspaces/$workspaceId/bots/$botId/conversations'
    | '/workspaces/$workspaceId/bots/$botId/events'
    | '/workspaces/$workspaceId/bots/$botId/files'
    | '/workspaces/$workspaceId/bots/$botId/hitl'
    | '/workspaces/$workspaceId/bots/$botId/integrations'
    | '/workspaces/$workspaceId/bots/$botId/logs'
    | '/workspaces/$workspaceId/bots/$botId/new-adk-bot-setup'
    | '/workspaces/$workspaceId/bots/$botId/new-bot'
    | '/workspaces/$workspaceId/bots/$botId/new-chat'
    | '/workspaces/$workspaceId/bots/$botId/overview'
    | '/workspaces/$workspaceId/bots/$botId/settings'
    | '/workspaces/$workspaceId/bots/$botId/users'
    | '/workspaces/$workspaceId/bots/$botId/vibe'
    | '/workspaces/$workspaceId/bots/$botId/webchat'
    | '/workspaces/$workspaceId/bots/$botId/workflows'
    | '/workspaces/$workspaceId/chatbots/$botId/$'
    | '/workspaces/$workspaceId/integrations/$integrationId/$'
    | '/workspaces/$workspaceId/integrations/$integrationId/logs'
    | '/workspaces/$workspaceId/integrations/$integrationId/settings'
    | '/workspaces/$workspaceId/integrations/$integrationId/versions'
    | '/workspaces/$workspaceId/bots/$botId/'
    | '/workspaces/$workspaceId/integrations/$integrationId/'
    | '/workspaces/$workspaceId/bots/$botId/conversationIdQuery/$messageId'
    | '/workspaces/$workspaceId/bots/$botId/conversations/$conversationId'
    | '/workspaces/$workspaceId/bots/$botId/issues/$issueId'
    | '/workspaces/$workspaceId/bots/$botId/settings/access-control'
    | '/workspaces/$workspaceId/bots/$botId/settings/general'
    | '/workspaces/$workspaceId/bots/$botId/tables/$tableId'
    | '/workspaces/$workspaceId/bots/$botId/issues/'
    | '/workspaces/$workspaceId/bots/$botId/knowledge-bases/'
    | '/workspaces/$workspaceId/bots/$botId/settings/'
    | '/workspaces/$workspaceId/bots/$botId/tables/'
    | '/workspaces/$workspaceId/bots/$botId/webchat/'
    | '/workspaces/$workspaceId/bots/$botId/knowledge-bases/$kbId/$dsId'
    | '/workspaces/$workspaceId/bots/$botId/webchat/v2/advanced-settings'
    | '/workspaces/$workspaceId/bots/$botId/webchat/v2/appearance'
    | '/workspaces/$workspaceId/bots/$botId/webchat/v2/deploy-settings'
    | '/workspaces/$workspaceId/bots/$botId/webchat/v2/features'
    | '/workspaces/$workspaceId/bots/$botId/webchat/v2/general'
    | '/workspaces/$workspaceId/bots/$botId/webchat/v2/identity'
    | '/workspaces/$workspaceId/bots/$botId/webchat/v2/share'
    | '/workspaces/$workspaceId/bots/$botId/knowledge-bases/$kbId/'
    | '/workspaces/$workspaceId/bots/$botId/conversations/$conversationId/messages/$messageId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SplatRoute: typeof SplatRoute
  CheckoutRoute: typeof CheckoutRoute
  CliLoginRoute: typeof CliLoginRoute
  ForbiddenRoute: typeof ForbiddenRoute
  WelcomeRoute: typeof WelcomeRoute
  OauthInterstitialRoute: typeof OauthInterstitialRoute
  ProfileAccountRoute: typeof ProfileAccountRoute
  ProfileSettingsRoute: typeof ProfileSettingsRoute
  WorkspacesWorkspaceIdRoute: typeof WorkspacesWorkspaceIdRouteWithChildren
  WorkspacesIndexRoute: typeof WorkspacesIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/welcome': {
      id: '/welcome'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof WelcomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forbidden': {
      id: '/forbidden'
      path: '/forbidden'
      fullPath: '/forbidden'
      preLoaderRoute: typeof ForbiddenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cli-login': {
      id: '/cli-login'
      path: '/cli-login'
      fullPath: '/cli-login'
      preLoaderRoute: typeof CliLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkout': {
      id: '/checkout'
      path: '/checkout'
      fullPath: '/checkout'
      preLoaderRoute: typeof CheckoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workspaces/': {
      id: '/workspaces/'
      path: '/workspaces'
      fullPath: '/workspaces'
      preLoaderRoute: typeof WorkspacesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workspaces/$workspaceId': {
      id: '/workspaces/$workspaceId'
      path: '/workspaces/$workspaceId'
      fullPath: '/workspaces/$workspaceId'
      preLoaderRoute: typeof WorkspacesWorkspaceIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/settings': {
      id: '/profile/settings'
      path: '/profile/settings'
      fullPath: '/profile/settings'
      preLoaderRoute: typeof ProfileSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile/account': {
      id: '/profile/account'
      path: '/profile/account'
      fullPath: '/profile/account'
      preLoaderRoute: typeof ProfileAccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oauth/interstitial': {
      id: '/oauth/interstitial'
      path: '/oauth/interstitial'
      fullPath: '/oauth/interstitial'
      preLoaderRoute: typeof OauthInterstitialRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workspaces/$workspaceId/': {
      id: '/workspaces/$workspaceId/'
      path: '/'
      fullPath: '/workspaces/$workspaceId/'
      preLoaderRoute: typeof WorkspacesWorkspaceIdIndexRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdRoute
    }
    '/workspaces/$workspaceId/usage': {
      id: '/workspaces/$workspaceId/usage'
      path: '/usage'
      fullPath: '/workspaces/$workspaceId/usage'
      preLoaderRoute: typeof WorkspacesWorkspaceIdUsageRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdRoute
    }
    '/workspaces/$workspaceId/settings': {
      id: '/workspaces/$workspaceId/settings'
      path: '/settings'
      fullPath: '/workspaces/$workspaceId/settings'
      preLoaderRoute: typeof WorkspacesWorkspaceIdSettingsRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdRoute
    }
    '/workspaces/$workspaceId/profile': {
      id: '/workspaces/$workspaceId/profile'
      path: '/profile'
      fullPath: '/workspaces/$workspaceId/profile'
      preLoaderRoute: typeof WorkspacesWorkspaceIdProfileRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdRoute
    }
    '/workspaces/$workspaceId/onboarding': {
      id: '/workspaces/$workspaceId/onboarding'
      path: '/onboarding'
      fullPath: '/workspaces/$workspaceId/onboarding'
      preLoaderRoute: typeof WorkspacesWorkspaceIdOnboardingRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdRoute
    }
    '/workspaces/$workspaceId/loading-bot': {
      id: '/workspaces/$workspaceId/loading-bot'
      path: '/loading-bot'
      fullPath: '/workspaces/$workspaceId/loading-bot'
      preLoaderRoute: typeof WorkspacesWorkspaceIdLoadingBotRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdRoute
    }
    '/workspaces/$workspaceId/home': {
      id: '/workspaces/$workspaceId/home'
      path: '/home'
      fullPath: '/workspaces/$workspaceId/home'
      preLoaderRoute: typeof WorkspacesWorkspaceIdHomeRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdRoute
    }
    '/workspaces/$workspaceId/create-bot': {
      id: '/workspaces/$workspaceId/create-bot'
      path: '/create-bot'
      fullPath: '/workspaces/$workspaceId/create-bot'
      preLoaderRoute: typeof WorkspacesWorkspaceIdCreateBotRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdRoute
    }
    '/workspaces/$workspaceId/checkout-trigger': {
      id: '/workspaces/$workspaceId/checkout-trigger'
      path: '/checkout-trigger'
      fullPath: '/workspaces/$workspaceId/checkout-trigger'
      preLoaderRoute: typeof WorkspacesWorkspaceIdCheckoutTriggerRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdRoute
    }
    '/workspaces/$workspaceId/chatbots_': {
      id: '/workspaces/$workspaceId/chatbots_'
      path: '/chatbots'
      fullPath: '/workspaces/$workspaceId/chatbots'
      preLoaderRoute: typeof WorkspacesWorkspaceIdChatbotsRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdRoute
    }
    '/workspaces/$workspaceId/bots_': {
      id: '/workspaces/$workspaceId/bots_'
      path: '/bots'
      fullPath: '/workspaces/$workspaceId/bots'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdRoute
    }
    '/workspaces/$workspaceId/billing': {
      id: '/workspaces/$workspaceId/billing'
      path: '/billing'
      fullPath: '/workspaces/$workspaceId/billing'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBillingRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdRoute
    }
    '/workspaces/$workspaceId/$': {
      id: '/workspaces/$workspaceId/$'
      path: '/$'
      fullPath: '/workspaces/$workspaceId/$'
      preLoaderRoute: typeof WorkspacesWorkspaceIdSplatRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdRoute
    }
    '/workspaces/$workspaceId/usage/': {
      id: '/workspaces/$workspaceId/usage/'
      path: '/'
      fullPath: '/workspaces/$workspaceId/usage/'
      preLoaderRoute: typeof WorkspacesWorkspaceIdUsageIndexRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdUsageRoute
    }
    '/workspaces/$workspaceId/settings/': {
      id: '/workspaces/$workspaceId/settings/'
      path: '/'
      fullPath: '/workspaces/$workspaceId/settings/'
      preLoaderRoute: typeof WorkspacesWorkspaceIdSettingsIndexRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdSettingsRoute
    }
    '/workspaces/$workspaceId/integrations/': {
      id: '/workspaces/$workspaceId/integrations/'
      path: '/integrations'
      fullPath: '/workspaces/$workspaceId/integrations'
      preLoaderRoute: typeof WorkspacesWorkspaceIdIntegrationsIndexRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdRoute
    }
    '/workspaces/$workspaceId/usage/monthly-summary': {
      id: '/workspaces/$workspaceId/usage/monthly-summary'
      path: '/monthly-summary'
      fullPath: '/workspaces/$workspaceId/usage/monthly-summary'
      preLoaderRoute: typeof WorkspacesWorkspaceIdUsageMonthlySummaryRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdUsageRoute
    }
    '/workspaces/$workspaceId/usage/ai-spend': {
      id: '/workspaces/$workspaceId/usage/ai-spend'
      path: '/ai-spend'
      fullPath: '/workspaces/$workspaceId/usage/ai-spend'
      preLoaderRoute: typeof WorkspacesWorkspaceIdUsageAiSpendRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdUsageRoute
    }
    '/workspaces/$workspaceId/settings/members': {
      id: '/workspaces/$workspaceId/settings/members'
      path: '/members'
      fullPath: '/workspaces/$workspaceId/settings/members'
      preLoaderRoute: typeof WorkspacesWorkspaceIdSettingsMembersRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdSettingsRoute
    }
    '/workspaces/$workspaceId/settings/details': {
      id: '/workspaces/$workspaceId/settings/details'
      path: '/details'
      fullPath: '/workspaces/$workspaceId/settings/details'
      preLoaderRoute: typeof WorkspacesWorkspaceIdSettingsDetailsRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdSettingsRoute
    }
    '/workspaces/$workspaceId/settings/audits': {
      id: '/workspaces/$workspaceId/settings/audits'
      path: '/audits'
      fullPath: '/workspaces/$workspaceId/settings/audits'
      preLoaderRoute: typeof WorkspacesWorkspaceIdSettingsAuditsRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdSettingsRoute
    }
    '/workspaces/$workspaceId/settings/$': {
      id: '/workspaces/$workspaceId/settings/$'
      path: '/$'
      fullPath: '/workspaces/$workspaceId/settings/$'
      preLoaderRoute: typeof WorkspacesWorkspaceIdSettingsSplatRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdSettingsRoute
    }
    '/workspaces/$workspaceId/profile/settings': {
      id: '/workspaces/$workspaceId/profile/settings'
      path: '/settings'
      fullPath: '/workspaces/$workspaceId/profile/settings'
      preLoaderRoute: typeof WorkspacesWorkspaceIdProfileSettingsRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdProfileRoute
    }
    '/workspaces/$workspaceId/profile/account': {
      id: '/workspaces/$workspaceId/profile/account'
      path: '/account'
      fullPath: '/workspaces/$workspaceId/profile/account'
      preLoaderRoute: typeof WorkspacesWorkspaceIdProfileAccountRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdProfileRoute
    }
    '/workspaces/$workspaceId/integrations/$integrationId': {
      id: '/workspaces/$workspaceId/integrations/$integrationId'
      path: '/integrations/$integrationId'
      fullPath: '/workspaces/$workspaceId/integrations/$integrationId'
      preLoaderRoute: typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdRoute
    }
    '/workspaces/$workspaceId/chatbots/$botId': {
      id: '/workspaces/$workspaceId/chatbots/$botId'
      path: '/chatbots/$botId'
      fullPath: '/workspaces/$workspaceId/chatbots/$botId'
      preLoaderRoute: typeof WorkspacesWorkspaceIdChatbotsBotIdRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdRoute
    }
    '/workspaces/$workspaceId/bots/$botId': {
      id: '/workspaces/$workspaceId/bots/$botId'
      path: '/bots/$botId'
      fullPath: '/workspaces/$workspaceId/bots/$botId'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdRoute
    }
    '/workspaces/$workspaceId/integrations/$integrationId/': {
      id: '/workspaces/$workspaceId/integrations/$integrationId/'
      path: '/'
      fullPath: '/workspaces/$workspaceId/integrations/$integrationId/'
      preLoaderRoute: typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdIndexRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdRoute
    }
    '/workspaces/$workspaceId/bots/$botId/': {
      id: '/workspaces/$workspaceId/bots/$botId/'
      path: '/'
      fullPath: '/workspaces/$workspaceId/bots/$botId/'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdIndexRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdRoute
    }
    '/workspaces/$workspaceId/integrations/$integrationId/versions': {
      id: '/workspaces/$workspaceId/integrations/$integrationId/versions'
      path: '/versions'
      fullPath: '/workspaces/$workspaceId/integrations/$integrationId/versions'
      preLoaderRoute: typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdVersionsRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdRoute
    }
    '/workspaces/$workspaceId/integrations/$integrationId/settings': {
      id: '/workspaces/$workspaceId/integrations/$integrationId/settings'
      path: '/settings'
      fullPath: '/workspaces/$workspaceId/integrations/$integrationId/settings'
      preLoaderRoute: typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdSettingsRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdRoute
    }
    '/workspaces/$workspaceId/integrations/$integrationId/logs': {
      id: '/workspaces/$workspaceId/integrations/$integrationId/logs'
      path: '/logs'
      fullPath: '/workspaces/$workspaceId/integrations/$integrationId/logs'
      preLoaderRoute: typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdLogsRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdRoute
    }
    '/workspaces/$workspaceId/integrations/$integrationId/$': {
      id: '/workspaces/$workspaceId/integrations/$integrationId/$'
      path: '/$'
      fullPath: '/workspaces/$workspaceId/integrations/$integrationId/$'
      preLoaderRoute: typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdSplatRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdRoute
    }
    '/workspaces/$workspaceId/chatbots/$botId/$': {
      id: '/workspaces/$workspaceId/chatbots/$botId/$'
      path: '/$'
      fullPath: '/workspaces/$workspaceId/chatbots/$botId/$'
      preLoaderRoute: typeof WorkspacesWorkspaceIdChatbotsBotIdSplatRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdChatbotsBotIdRoute
    }
    '/workspaces/$workspaceId/bots/$botId/workflows': {
      id: '/workspaces/$workspaceId/bots/$botId/workflows'
      path: '/workflows'
      fullPath: '/workspaces/$workspaceId/bots/$botId/workflows'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdWorkflowsRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdRoute
    }
    '/workspaces/$workspaceId/bots/$botId/webchat': {
      id: '/workspaces/$workspaceId/bots/$botId/webchat'
      path: '/webchat'
      fullPath: '/workspaces/$workspaceId/bots/$botId/webchat'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdWebchatRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdRoute
    }
    '/workspaces/$workspaceId/bots/$botId/vibe': {
      id: '/workspaces/$workspaceId/bots/$botId/vibe'
      path: '/vibe'
      fullPath: '/workspaces/$workspaceId/bots/$botId/vibe'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdVibeRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdRoute
    }
    '/workspaces/$workspaceId/bots/$botId/users': {
      id: '/workspaces/$workspaceId/bots/$botId/users'
      path: '/users'
      fullPath: '/workspaces/$workspaceId/bots/$botId/users'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdUsersRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdRoute
    }
    '/workspaces/$workspaceId/bots/$botId/settings': {
      id: '/workspaces/$workspaceId/bots/$botId/settings'
      path: '/settings'
      fullPath: '/workspaces/$workspaceId/bots/$botId/settings'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdSettingsRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdRoute
    }
    '/workspaces/$workspaceId/bots/$botId/overview': {
      id: '/workspaces/$workspaceId/bots/$botId/overview'
      path: '/overview'
      fullPath: '/workspaces/$workspaceId/bots/$botId/overview'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdOverviewRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdRoute
    }
    '/workspaces/$workspaceId/bots/$botId/new-chat': {
      id: '/workspaces/$workspaceId/bots/$botId/new-chat'
      path: '/new-chat'
      fullPath: '/workspaces/$workspaceId/bots/$botId/new-chat'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdNewChatRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdRoute
    }
    '/workspaces/$workspaceId/bots/$botId/new-bot': {
      id: '/workspaces/$workspaceId/bots/$botId/new-bot'
      path: '/new-bot'
      fullPath: '/workspaces/$workspaceId/bots/$botId/new-bot'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdNewBotRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdRoute
    }
    '/workspaces/$workspaceId/bots/$botId/new-adk-bot-setup': {
      id: '/workspaces/$workspaceId/bots/$botId/new-adk-bot-setup'
      path: '/new-adk-bot-setup'
      fullPath: '/workspaces/$workspaceId/bots/$botId/new-adk-bot-setup'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdNewAdkBotSetupRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdRoute
    }
    '/workspaces/$workspaceId/bots/$botId/logs': {
      id: '/workspaces/$workspaceId/bots/$botId/logs'
      path: '/logs'
      fullPath: '/workspaces/$workspaceId/bots/$botId/logs'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdLogsRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdRoute
    }
    '/workspaces/$workspaceId/bots/$botId/integrations': {
      id: '/workspaces/$workspaceId/bots/$botId/integrations'
      path: '/integrations'
      fullPath: '/workspaces/$workspaceId/bots/$botId/integrations'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdIntegrationsRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdRoute
    }
    '/workspaces/$workspaceId/bots/$botId/hitl': {
      id: '/workspaces/$workspaceId/bots/$botId/hitl'
      path: '/hitl'
      fullPath: '/workspaces/$workspaceId/bots/$botId/hitl'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdHitlRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdRoute
    }
    '/workspaces/$workspaceId/bots/$botId/files': {
      id: '/workspaces/$workspaceId/bots/$botId/files'
      path: '/files'
      fullPath: '/workspaces/$workspaceId/bots/$botId/files'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdFilesRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdRoute
    }
    '/workspaces/$workspaceId/bots/$botId/events': {
      id: '/workspaces/$workspaceId/bots/$botId/events'
      path: '/events'
      fullPath: '/workspaces/$workspaceId/bots/$botId/events'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdEventsRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdRoute
    }
    '/workspaces/$workspaceId/bots/$botId/conversations': {
      id: '/workspaces/$workspaceId/bots/$botId/conversations'
      path: '/conversations'
      fullPath: '/workspaces/$workspaceId/bots/$botId/conversations'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdConversationsRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdRoute
    }
    '/workspaces/$workspaceId/bots/$botId/analytics': {
      id: '/workspaces/$workspaceId/bots/$botId/analytics'
      path: '/analytics'
      fullPath: '/workspaces/$workspaceId/bots/$botId/analytics'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdAnalyticsRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdRoute
    }
    '/workspaces/$workspaceId/bots/$botId/$': {
      id: '/workspaces/$workspaceId/bots/$botId/$'
      path: '/$'
      fullPath: '/workspaces/$workspaceId/bots/$botId/$'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdSplatRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdRoute
    }
    '/workspaces/$workspaceId/bots/$botId/webchat/': {
      id: '/workspaces/$workspaceId/bots/$botId/webchat/'
      path: '/'
      fullPath: '/workspaces/$workspaceId/bots/$botId/webchat/'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdWebchatIndexRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdWebchatRoute
    }
    '/workspaces/$workspaceId/bots/$botId/tables/': {
      id: '/workspaces/$workspaceId/bots/$botId/tables/'
      path: '/tables'
      fullPath: '/workspaces/$workspaceId/bots/$botId/tables'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdTablesIndexRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdRoute
    }
    '/workspaces/$workspaceId/bots/$botId/settings/': {
      id: '/workspaces/$workspaceId/bots/$botId/settings/'
      path: '/'
      fullPath: '/workspaces/$workspaceId/bots/$botId/settings/'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdSettingsIndexRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdSettingsRoute
    }
    '/workspaces/$workspaceId/bots/$botId/knowledge-bases/': {
      id: '/workspaces/$workspaceId/bots/$botId/knowledge-bases/'
      path: '/knowledge-bases'
      fullPath: '/workspaces/$workspaceId/bots/$botId/knowledge-bases'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesIndexRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdRoute
    }
    '/workspaces/$workspaceId/bots/$botId/issues/': {
      id: '/workspaces/$workspaceId/bots/$botId/issues/'
      path: '/issues'
      fullPath: '/workspaces/$workspaceId/bots/$botId/issues'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdIssuesIndexRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdRoute
    }
    '/workspaces/$workspaceId/bots/$botId/tables/$tableId': {
      id: '/workspaces/$workspaceId/bots/$botId/tables/$tableId'
      path: '/tables/$tableId'
      fullPath: '/workspaces/$workspaceId/bots/$botId/tables/$tableId'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdTablesTableIdRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdRoute
    }
    '/workspaces/$workspaceId/bots/$botId/settings/general': {
      id: '/workspaces/$workspaceId/bots/$botId/settings/general'
      path: '/general'
      fullPath: '/workspaces/$workspaceId/bots/$botId/settings/general'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdSettingsGeneralRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdSettingsRoute
    }
    '/workspaces/$workspaceId/bots/$botId/settings/access-control': {
      id: '/workspaces/$workspaceId/bots/$botId/settings/access-control'
      path: '/access-control'
      fullPath: '/workspaces/$workspaceId/bots/$botId/settings/access-control'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdSettingsAccessControlRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdSettingsRoute
    }
    '/workspaces/$workspaceId/bots/$botId/issues/$issueId': {
      id: '/workspaces/$workspaceId/bots/$botId/issues/$issueId'
      path: '/issues/$issueId'
      fullPath: '/workspaces/$workspaceId/bots/$botId/issues/$issueId'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdIssuesIssueIdRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdRoute
    }
    '/workspaces/$workspaceId/bots/$botId/conversations/$conversationId': {
      id: '/workspaces/$workspaceId/bots/$botId/conversations/$conversationId'
      path: '/$conversationId'
      fullPath: '/workspaces/$workspaceId/bots/$botId/conversations/$conversationId'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdConversationsRoute
    }
    '/workspaces/$workspaceId/bots/$botId/conversationIdQuery/$messageId': {
      id: '/workspaces/$workspaceId/bots/$botId/conversationIdQuery/$messageId'
      path: '/conversationIdQuery/$messageId'
      fullPath: '/workspaces/$workspaceId/bots/$botId/conversationIdQuery/$messageId'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdConversationIdQueryMessageIdRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdRoute
    }
    '/workspaces/$workspaceId/bots/$botId/knowledge-bases/$kbId/': {
      id: '/workspaces/$workspaceId/bots/$botId/knowledge-bases/$kbId/'
      path: '/knowledge-bases/$kbId'
      fullPath: '/workspaces/$workspaceId/bots/$botId/knowledge-bases/$kbId'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesKbIdIndexRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdRoute
    }
    '/workspaces/$workspaceId/bots/$botId/webchat/v2/share': {
      id: '/workspaces/$workspaceId/bots/$botId/webchat/v2/share'
      path: '/v2/share'
      fullPath: '/workspaces/$workspaceId/bots/$botId/webchat/v2/share'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdWebchatV2ShareRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdWebchatRoute
    }
    '/workspaces/$workspaceId/bots/$botId/webchat/v2/identity': {
      id: '/workspaces/$workspaceId/bots/$botId/webchat/v2/identity'
      path: '/v2/identity'
      fullPath: '/workspaces/$workspaceId/bots/$botId/webchat/v2/identity'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdWebchatV2IdentityRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdWebchatRoute
    }
    '/workspaces/$workspaceId/bots/$botId/webchat/v2/general': {
      id: '/workspaces/$workspaceId/bots/$botId/webchat/v2/general'
      path: '/v2/general'
      fullPath: '/workspaces/$workspaceId/bots/$botId/webchat/v2/general'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdWebchatV2GeneralRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdWebchatRoute
    }
    '/workspaces/$workspaceId/bots/$botId/webchat/v2/features': {
      id: '/workspaces/$workspaceId/bots/$botId/webchat/v2/features'
      path: '/v2/features'
      fullPath: '/workspaces/$workspaceId/bots/$botId/webchat/v2/features'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdWebchatV2FeaturesRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdWebchatRoute
    }
    '/workspaces/$workspaceId/bots/$botId/webchat/v2/deploy-settings': {
      id: '/workspaces/$workspaceId/bots/$botId/webchat/v2/deploy-settings'
      path: '/v2/deploy-settings'
      fullPath: '/workspaces/$workspaceId/bots/$botId/webchat/v2/deploy-settings'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdWebchatV2DeploySettingsRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdWebchatRoute
    }
    '/workspaces/$workspaceId/bots/$botId/webchat/v2/appearance': {
      id: '/workspaces/$workspaceId/bots/$botId/webchat/v2/appearance'
      path: '/v2/appearance'
      fullPath: '/workspaces/$workspaceId/bots/$botId/webchat/v2/appearance'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdWebchatV2AppearanceRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdWebchatRoute
    }
    '/workspaces/$workspaceId/bots/$botId/webchat/v2/advanced-settings': {
      id: '/workspaces/$workspaceId/bots/$botId/webchat/v2/advanced-settings'
      path: '/v2/advanced-settings'
      fullPath: '/workspaces/$workspaceId/bots/$botId/webchat/v2/advanced-settings'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdWebchatV2AdvancedSettingsRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdWebchatRoute
    }
    '/workspaces/$workspaceId/bots/$botId/knowledge-bases/$kbId/$dsId': {
      id: '/workspaces/$workspaceId/bots/$botId/knowledge-bases/$kbId/$dsId'
      path: '/knowledge-bases/$kbId/$dsId'
      fullPath: '/workspaces/$workspaceId/bots/$botId/knowledge-bases/$kbId/$dsId'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesKbIdDsIdRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdRoute
    }
    '/workspaces/$workspaceId/bots/$botId/conversations/$conversationId/messages/$messageId': {
      id: '/workspaces/$workspaceId/bots/$botId/conversations/$conversationId/messages/$messageId'
      path: '/messages/$messageId'
      fullPath: '/workspaces/$workspaceId/bots/$botId/conversations/$conversationId/messages/$messageId'
      preLoaderRoute: typeof WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdMessagesMessageIdRouteImport
      parentRoute: typeof WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdRoute
    }
  }
}

interface WorkspacesWorkspaceIdProfileRouteChildren {
  WorkspacesWorkspaceIdProfileAccountRoute: typeof WorkspacesWorkspaceIdProfileAccountRoute
  WorkspacesWorkspaceIdProfileSettingsRoute: typeof WorkspacesWorkspaceIdProfileSettingsRoute
}

const WorkspacesWorkspaceIdProfileRouteChildren: WorkspacesWorkspaceIdProfileRouteChildren =
  {
    WorkspacesWorkspaceIdProfileAccountRoute:
      WorkspacesWorkspaceIdProfileAccountRoute,
    WorkspacesWorkspaceIdProfileSettingsRoute:
      WorkspacesWorkspaceIdProfileSettingsRoute,
  }

const WorkspacesWorkspaceIdProfileRouteWithChildren =
  WorkspacesWorkspaceIdProfileRoute._addFileChildren(
    WorkspacesWorkspaceIdProfileRouteChildren,
  )

interface WorkspacesWorkspaceIdSettingsRouteChildren {
  WorkspacesWorkspaceIdSettingsSplatRoute: typeof WorkspacesWorkspaceIdSettingsSplatRoute
  WorkspacesWorkspaceIdSettingsAuditsRoute: typeof WorkspacesWorkspaceIdSettingsAuditsRoute
  WorkspacesWorkspaceIdSettingsDetailsRoute: typeof WorkspacesWorkspaceIdSettingsDetailsRoute
  WorkspacesWorkspaceIdSettingsMembersRoute: typeof WorkspacesWorkspaceIdSettingsMembersRoute
  WorkspacesWorkspaceIdSettingsIndexRoute: typeof WorkspacesWorkspaceIdSettingsIndexRoute
}

const WorkspacesWorkspaceIdSettingsRouteChildren: WorkspacesWorkspaceIdSettingsRouteChildren =
  {
    WorkspacesWorkspaceIdSettingsSplatRoute:
      WorkspacesWorkspaceIdSettingsSplatRoute,
    WorkspacesWorkspaceIdSettingsAuditsRoute:
      WorkspacesWorkspaceIdSettingsAuditsRoute,
    WorkspacesWorkspaceIdSettingsDetailsRoute:
      WorkspacesWorkspaceIdSettingsDetailsRoute,
    WorkspacesWorkspaceIdSettingsMembersRoute:
      WorkspacesWorkspaceIdSettingsMembersRoute,
    WorkspacesWorkspaceIdSettingsIndexRoute:
      WorkspacesWorkspaceIdSettingsIndexRoute,
  }

const WorkspacesWorkspaceIdSettingsRouteWithChildren =
  WorkspacesWorkspaceIdSettingsRoute._addFileChildren(
    WorkspacesWorkspaceIdSettingsRouteChildren,
  )

interface WorkspacesWorkspaceIdUsageRouteChildren {
  WorkspacesWorkspaceIdUsageAiSpendRoute: typeof WorkspacesWorkspaceIdUsageAiSpendRoute
  WorkspacesWorkspaceIdUsageMonthlySummaryRoute: typeof WorkspacesWorkspaceIdUsageMonthlySummaryRoute
  WorkspacesWorkspaceIdUsageIndexRoute: typeof WorkspacesWorkspaceIdUsageIndexRoute
}

const WorkspacesWorkspaceIdUsageRouteChildren: WorkspacesWorkspaceIdUsageRouteChildren =
  {
    WorkspacesWorkspaceIdUsageAiSpendRoute:
      WorkspacesWorkspaceIdUsageAiSpendRoute,
    WorkspacesWorkspaceIdUsageMonthlySummaryRoute:
      WorkspacesWorkspaceIdUsageMonthlySummaryRoute,
    WorkspacesWorkspaceIdUsageIndexRoute: WorkspacesWorkspaceIdUsageIndexRoute,
  }

const WorkspacesWorkspaceIdUsageRouteWithChildren =
  WorkspacesWorkspaceIdUsageRoute._addFileChildren(
    WorkspacesWorkspaceIdUsageRouteChildren,
  )

interface WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdRouteChildren {
  WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdMessagesMessageIdRoute: typeof WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdMessagesMessageIdRoute
}

const WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdRouteChildren: WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdRouteChildren =
  {
    WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdMessagesMessageIdRoute:
      WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdMessagesMessageIdRoute,
  }

const WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdRouteWithChildren =
  WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdRoute._addFileChildren(
    WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdRouteChildren,
  )

interface WorkspacesWorkspaceIdBotsBotIdConversationsRouteChildren {
  WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdRoute: typeof WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdRouteWithChildren
}

const WorkspacesWorkspaceIdBotsBotIdConversationsRouteChildren: WorkspacesWorkspaceIdBotsBotIdConversationsRouteChildren =
  {
    WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdRoute:
      WorkspacesWorkspaceIdBotsBotIdConversationsConversationIdRouteWithChildren,
  }

const WorkspacesWorkspaceIdBotsBotIdConversationsRouteWithChildren =
  WorkspacesWorkspaceIdBotsBotIdConversationsRoute._addFileChildren(
    WorkspacesWorkspaceIdBotsBotIdConversationsRouteChildren,
  )

interface WorkspacesWorkspaceIdBotsBotIdSettingsRouteChildren {
  WorkspacesWorkspaceIdBotsBotIdSettingsAccessControlRoute: typeof WorkspacesWorkspaceIdBotsBotIdSettingsAccessControlRoute
  WorkspacesWorkspaceIdBotsBotIdSettingsGeneralRoute: typeof WorkspacesWorkspaceIdBotsBotIdSettingsGeneralRoute
  WorkspacesWorkspaceIdBotsBotIdSettingsIndexRoute: typeof WorkspacesWorkspaceIdBotsBotIdSettingsIndexRoute
}

const WorkspacesWorkspaceIdBotsBotIdSettingsRouteChildren: WorkspacesWorkspaceIdBotsBotIdSettingsRouteChildren =
  {
    WorkspacesWorkspaceIdBotsBotIdSettingsAccessControlRoute:
      WorkspacesWorkspaceIdBotsBotIdSettingsAccessControlRoute,
    WorkspacesWorkspaceIdBotsBotIdSettingsGeneralRoute:
      WorkspacesWorkspaceIdBotsBotIdSettingsGeneralRoute,
    WorkspacesWorkspaceIdBotsBotIdSettingsIndexRoute:
      WorkspacesWorkspaceIdBotsBotIdSettingsIndexRoute,
  }

const WorkspacesWorkspaceIdBotsBotIdSettingsRouteWithChildren =
  WorkspacesWorkspaceIdBotsBotIdSettingsRoute._addFileChildren(
    WorkspacesWorkspaceIdBotsBotIdSettingsRouteChildren,
  )

interface WorkspacesWorkspaceIdBotsBotIdWebchatRouteChildren {
  WorkspacesWorkspaceIdBotsBotIdWebchatIndexRoute: typeof WorkspacesWorkspaceIdBotsBotIdWebchatIndexRoute
  WorkspacesWorkspaceIdBotsBotIdWebchatV2AdvancedSettingsRoute: typeof WorkspacesWorkspaceIdBotsBotIdWebchatV2AdvancedSettingsRoute
  WorkspacesWorkspaceIdBotsBotIdWebchatV2AppearanceRoute: typeof WorkspacesWorkspaceIdBotsBotIdWebchatV2AppearanceRoute
  WorkspacesWorkspaceIdBotsBotIdWebchatV2DeploySettingsRoute: typeof WorkspacesWorkspaceIdBotsBotIdWebchatV2DeploySettingsRoute
  WorkspacesWorkspaceIdBotsBotIdWebchatV2FeaturesRoute: typeof WorkspacesWorkspaceIdBotsBotIdWebchatV2FeaturesRoute
  WorkspacesWorkspaceIdBotsBotIdWebchatV2GeneralRoute: typeof WorkspacesWorkspaceIdBotsBotIdWebchatV2GeneralRoute
  WorkspacesWorkspaceIdBotsBotIdWebchatV2IdentityRoute: typeof WorkspacesWorkspaceIdBotsBotIdWebchatV2IdentityRoute
  WorkspacesWorkspaceIdBotsBotIdWebchatV2ShareRoute: typeof WorkspacesWorkspaceIdBotsBotIdWebchatV2ShareRoute
}

const WorkspacesWorkspaceIdBotsBotIdWebchatRouteChildren: WorkspacesWorkspaceIdBotsBotIdWebchatRouteChildren =
  {
    WorkspacesWorkspaceIdBotsBotIdWebchatIndexRoute:
      WorkspacesWorkspaceIdBotsBotIdWebchatIndexRoute,
    WorkspacesWorkspaceIdBotsBotIdWebchatV2AdvancedSettingsRoute:
      WorkspacesWorkspaceIdBotsBotIdWebchatV2AdvancedSettingsRoute,
    WorkspacesWorkspaceIdBotsBotIdWebchatV2AppearanceRoute:
      WorkspacesWorkspaceIdBotsBotIdWebchatV2AppearanceRoute,
    WorkspacesWorkspaceIdBotsBotIdWebchatV2DeploySettingsRoute:
      WorkspacesWorkspaceIdBotsBotIdWebchatV2DeploySettingsRoute,
    WorkspacesWorkspaceIdBotsBotIdWebchatV2FeaturesRoute:
      WorkspacesWorkspaceIdBotsBotIdWebchatV2FeaturesRoute,
    WorkspacesWorkspaceIdBotsBotIdWebchatV2GeneralRoute:
      WorkspacesWorkspaceIdBotsBotIdWebchatV2GeneralRoute,
    WorkspacesWorkspaceIdBotsBotIdWebchatV2IdentityRoute:
      WorkspacesWorkspaceIdBotsBotIdWebchatV2IdentityRoute,
    WorkspacesWorkspaceIdBotsBotIdWebchatV2ShareRoute:
      WorkspacesWorkspaceIdBotsBotIdWebchatV2ShareRoute,
  }

const WorkspacesWorkspaceIdBotsBotIdWebchatRouteWithChildren =
  WorkspacesWorkspaceIdBotsBotIdWebchatRoute._addFileChildren(
    WorkspacesWorkspaceIdBotsBotIdWebchatRouteChildren,
  )

interface WorkspacesWorkspaceIdBotsBotIdRouteChildren {
  WorkspacesWorkspaceIdBotsBotIdSplatRoute: typeof WorkspacesWorkspaceIdBotsBotIdSplatRoute
  WorkspacesWorkspaceIdBotsBotIdAnalyticsRoute: typeof WorkspacesWorkspaceIdBotsBotIdAnalyticsRoute
  WorkspacesWorkspaceIdBotsBotIdConversationsRoute: typeof WorkspacesWorkspaceIdBotsBotIdConversationsRouteWithChildren
  WorkspacesWorkspaceIdBotsBotIdEventsRoute: typeof WorkspacesWorkspaceIdBotsBotIdEventsRoute
  WorkspacesWorkspaceIdBotsBotIdFilesRoute: typeof WorkspacesWorkspaceIdBotsBotIdFilesRoute
  WorkspacesWorkspaceIdBotsBotIdHitlRoute: typeof WorkspacesWorkspaceIdBotsBotIdHitlRoute
  WorkspacesWorkspaceIdBotsBotIdIntegrationsRoute: typeof WorkspacesWorkspaceIdBotsBotIdIntegrationsRoute
  WorkspacesWorkspaceIdBotsBotIdLogsRoute: typeof WorkspacesWorkspaceIdBotsBotIdLogsRoute
  WorkspacesWorkspaceIdBotsBotIdNewAdkBotSetupRoute: typeof WorkspacesWorkspaceIdBotsBotIdNewAdkBotSetupRoute
  WorkspacesWorkspaceIdBotsBotIdNewBotRoute: typeof WorkspacesWorkspaceIdBotsBotIdNewBotRoute
  WorkspacesWorkspaceIdBotsBotIdNewChatRoute: typeof WorkspacesWorkspaceIdBotsBotIdNewChatRoute
  WorkspacesWorkspaceIdBotsBotIdOverviewRoute: typeof WorkspacesWorkspaceIdBotsBotIdOverviewRoute
  WorkspacesWorkspaceIdBotsBotIdSettingsRoute: typeof WorkspacesWorkspaceIdBotsBotIdSettingsRouteWithChildren
  WorkspacesWorkspaceIdBotsBotIdUsersRoute: typeof WorkspacesWorkspaceIdBotsBotIdUsersRoute
  WorkspacesWorkspaceIdBotsBotIdVibeRoute: typeof WorkspacesWorkspaceIdBotsBotIdVibeRoute
  WorkspacesWorkspaceIdBotsBotIdWebchatRoute: typeof WorkspacesWorkspaceIdBotsBotIdWebchatRouteWithChildren
  WorkspacesWorkspaceIdBotsBotIdWorkflowsRoute: typeof WorkspacesWorkspaceIdBotsBotIdWorkflowsRoute
  WorkspacesWorkspaceIdBotsBotIdIndexRoute: typeof WorkspacesWorkspaceIdBotsBotIdIndexRoute
  WorkspacesWorkspaceIdBotsBotIdConversationIdQueryMessageIdRoute: typeof WorkspacesWorkspaceIdBotsBotIdConversationIdQueryMessageIdRoute
  WorkspacesWorkspaceIdBotsBotIdIssuesIssueIdRoute: typeof WorkspacesWorkspaceIdBotsBotIdIssuesIssueIdRoute
  WorkspacesWorkspaceIdBotsBotIdTablesTableIdRoute: typeof WorkspacesWorkspaceIdBotsBotIdTablesTableIdRoute
  WorkspacesWorkspaceIdBotsBotIdIssuesIndexRoute: typeof WorkspacesWorkspaceIdBotsBotIdIssuesIndexRoute
  WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesIndexRoute: typeof WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesIndexRoute
  WorkspacesWorkspaceIdBotsBotIdTablesIndexRoute: typeof WorkspacesWorkspaceIdBotsBotIdTablesIndexRoute
  WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesKbIdDsIdRoute: typeof WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesKbIdDsIdRoute
  WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesKbIdIndexRoute: typeof WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesKbIdIndexRoute
}

const WorkspacesWorkspaceIdBotsBotIdRouteChildren: WorkspacesWorkspaceIdBotsBotIdRouteChildren =
  {
    WorkspacesWorkspaceIdBotsBotIdSplatRoute:
      WorkspacesWorkspaceIdBotsBotIdSplatRoute,
    WorkspacesWorkspaceIdBotsBotIdAnalyticsRoute:
      WorkspacesWorkspaceIdBotsBotIdAnalyticsRoute,
    WorkspacesWorkspaceIdBotsBotIdConversationsRoute:
      WorkspacesWorkspaceIdBotsBotIdConversationsRouteWithChildren,
    WorkspacesWorkspaceIdBotsBotIdEventsRoute:
      WorkspacesWorkspaceIdBotsBotIdEventsRoute,
    WorkspacesWorkspaceIdBotsBotIdFilesRoute:
      WorkspacesWorkspaceIdBotsBotIdFilesRoute,
    WorkspacesWorkspaceIdBotsBotIdHitlRoute:
      WorkspacesWorkspaceIdBotsBotIdHitlRoute,
    WorkspacesWorkspaceIdBotsBotIdIntegrationsRoute:
      WorkspacesWorkspaceIdBotsBotIdIntegrationsRoute,
    WorkspacesWorkspaceIdBotsBotIdLogsRoute:
      WorkspacesWorkspaceIdBotsBotIdLogsRoute,
    WorkspacesWorkspaceIdBotsBotIdNewAdkBotSetupRoute:
      WorkspacesWorkspaceIdBotsBotIdNewAdkBotSetupRoute,
    WorkspacesWorkspaceIdBotsBotIdNewBotRoute:
      WorkspacesWorkspaceIdBotsBotIdNewBotRoute,
    WorkspacesWorkspaceIdBotsBotIdNewChatRoute:
      WorkspacesWorkspaceIdBotsBotIdNewChatRoute,
    WorkspacesWorkspaceIdBotsBotIdOverviewRoute:
      WorkspacesWorkspaceIdBotsBotIdOverviewRoute,
    WorkspacesWorkspaceIdBotsBotIdSettingsRoute:
      WorkspacesWorkspaceIdBotsBotIdSettingsRouteWithChildren,
    WorkspacesWorkspaceIdBotsBotIdUsersRoute:
      WorkspacesWorkspaceIdBotsBotIdUsersRoute,
    WorkspacesWorkspaceIdBotsBotIdVibeRoute:
      WorkspacesWorkspaceIdBotsBotIdVibeRoute,
    WorkspacesWorkspaceIdBotsBotIdWebchatRoute:
      WorkspacesWorkspaceIdBotsBotIdWebchatRouteWithChildren,
    WorkspacesWorkspaceIdBotsBotIdWorkflowsRoute:
      WorkspacesWorkspaceIdBotsBotIdWorkflowsRoute,
    WorkspacesWorkspaceIdBotsBotIdIndexRoute:
      WorkspacesWorkspaceIdBotsBotIdIndexRoute,
    WorkspacesWorkspaceIdBotsBotIdConversationIdQueryMessageIdRoute:
      WorkspacesWorkspaceIdBotsBotIdConversationIdQueryMessageIdRoute,
    WorkspacesWorkspaceIdBotsBotIdIssuesIssueIdRoute:
      WorkspacesWorkspaceIdBotsBotIdIssuesIssueIdRoute,
    WorkspacesWorkspaceIdBotsBotIdTablesTableIdRoute:
      WorkspacesWorkspaceIdBotsBotIdTablesTableIdRoute,
    WorkspacesWorkspaceIdBotsBotIdIssuesIndexRoute:
      WorkspacesWorkspaceIdBotsBotIdIssuesIndexRoute,
    WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesIndexRoute:
      WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesIndexRoute,
    WorkspacesWorkspaceIdBotsBotIdTablesIndexRoute:
      WorkspacesWorkspaceIdBotsBotIdTablesIndexRoute,
    WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesKbIdDsIdRoute:
      WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesKbIdDsIdRoute,
    WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesKbIdIndexRoute:
      WorkspacesWorkspaceIdBotsBotIdKnowledgeBasesKbIdIndexRoute,
  }

const WorkspacesWorkspaceIdBotsBotIdRouteWithChildren =
  WorkspacesWorkspaceIdBotsBotIdRoute._addFileChildren(
    WorkspacesWorkspaceIdBotsBotIdRouteChildren,
  )

interface WorkspacesWorkspaceIdChatbotsBotIdRouteChildren {
  WorkspacesWorkspaceIdChatbotsBotIdSplatRoute: typeof WorkspacesWorkspaceIdChatbotsBotIdSplatRoute
}

const WorkspacesWorkspaceIdChatbotsBotIdRouteChildren: WorkspacesWorkspaceIdChatbotsBotIdRouteChildren =
  {
    WorkspacesWorkspaceIdChatbotsBotIdSplatRoute:
      WorkspacesWorkspaceIdChatbotsBotIdSplatRoute,
  }

const WorkspacesWorkspaceIdChatbotsBotIdRouteWithChildren =
  WorkspacesWorkspaceIdChatbotsBotIdRoute._addFileChildren(
    WorkspacesWorkspaceIdChatbotsBotIdRouteChildren,
  )

interface WorkspacesWorkspaceIdIntegrationsIntegrationIdRouteChildren {
  WorkspacesWorkspaceIdIntegrationsIntegrationIdSplatRoute: typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdSplatRoute
  WorkspacesWorkspaceIdIntegrationsIntegrationIdLogsRoute: typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdLogsRoute
  WorkspacesWorkspaceIdIntegrationsIntegrationIdSettingsRoute: typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdSettingsRoute
  WorkspacesWorkspaceIdIntegrationsIntegrationIdVersionsRoute: typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdVersionsRoute
  WorkspacesWorkspaceIdIntegrationsIntegrationIdIndexRoute: typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdIndexRoute
}

const WorkspacesWorkspaceIdIntegrationsIntegrationIdRouteChildren: WorkspacesWorkspaceIdIntegrationsIntegrationIdRouteChildren =
  {
    WorkspacesWorkspaceIdIntegrationsIntegrationIdSplatRoute:
      WorkspacesWorkspaceIdIntegrationsIntegrationIdSplatRoute,
    WorkspacesWorkspaceIdIntegrationsIntegrationIdLogsRoute:
      WorkspacesWorkspaceIdIntegrationsIntegrationIdLogsRoute,
    WorkspacesWorkspaceIdIntegrationsIntegrationIdSettingsRoute:
      WorkspacesWorkspaceIdIntegrationsIntegrationIdSettingsRoute,
    WorkspacesWorkspaceIdIntegrationsIntegrationIdVersionsRoute:
      WorkspacesWorkspaceIdIntegrationsIntegrationIdVersionsRoute,
    WorkspacesWorkspaceIdIntegrationsIntegrationIdIndexRoute:
      WorkspacesWorkspaceIdIntegrationsIntegrationIdIndexRoute,
  }

const WorkspacesWorkspaceIdIntegrationsIntegrationIdRouteWithChildren =
  WorkspacesWorkspaceIdIntegrationsIntegrationIdRoute._addFileChildren(
    WorkspacesWorkspaceIdIntegrationsIntegrationIdRouteChildren,
  )

interface WorkspacesWorkspaceIdRouteChildren {
  WorkspacesWorkspaceIdSplatRoute: typeof WorkspacesWorkspaceIdSplatRoute
  WorkspacesWorkspaceIdBillingRoute: typeof WorkspacesWorkspaceIdBillingRoute
  WorkspacesWorkspaceIdBotsRoute: typeof WorkspacesWorkspaceIdBotsRoute
  WorkspacesWorkspaceIdChatbotsRoute: typeof WorkspacesWorkspaceIdChatbotsRoute
  WorkspacesWorkspaceIdCheckoutTriggerRoute: typeof WorkspacesWorkspaceIdCheckoutTriggerRoute
  WorkspacesWorkspaceIdCreateBotRoute: typeof WorkspacesWorkspaceIdCreateBotRoute
  WorkspacesWorkspaceIdHomeRoute: typeof WorkspacesWorkspaceIdHomeRoute
  WorkspacesWorkspaceIdLoadingBotRoute: typeof WorkspacesWorkspaceIdLoadingBotRoute
  WorkspacesWorkspaceIdOnboardingRoute: typeof WorkspacesWorkspaceIdOnboardingRoute
  WorkspacesWorkspaceIdProfileRoute: typeof WorkspacesWorkspaceIdProfileRouteWithChildren
  WorkspacesWorkspaceIdSettingsRoute: typeof WorkspacesWorkspaceIdSettingsRouteWithChildren
  WorkspacesWorkspaceIdUsageRoute: typeof WorkspacesWorkspaceIdUsageRouteWithChildren
  WorkspacesWorkspaceIdIndexRoute: typeof WorkspacesWorkspaceIdIndexRoute
  WorkspacesWorkspaceIdBotsBotIdRoute: typeof WorkspacesWorkspaceIdBotsBotIdRouteWithChildren
  WorkspacesWorkspaceIdChatbotsBotIdRoute: typeof WorkspacesWorkspaceIdChatbotsBotIdRouteWithChildren
  WorkspacesWorkspaceIdIntegrationsIntegrationIdRoute: typeof WorkspacesWorkspaceIdIntegrationsIntegrationIdRouteWithChildren
  WorkspacesWorkspaceIdIntegrationsIndexRoute: typeof WorkspacesWorkspaceIdIntegrationsIndexRoute
}

const WorkspacesWorkspaceIdRouteChildren: WorkspacesWorkspaceIdRouteChildren = {
  WorkspacesWorkspaceIdSplatRoute: WorkspacesWorkspaceIdSplatRoute,
  WorkspacesWorkspaceIdBillingRoute: WorkspacesWorkspaceIdBillingRoute,
  WorkspacesWorkspaceIdBotsRoute: WorkspacesWorkspaceIdBotsRoute,
  WorkspacesWorkspaceIdChatbotsRoute: WorkspacesWorkspaceIdChatbotsRoute,
  WorkspacesWorkspaceIdCheckoutTriggerRoute:
    WorkspacesWorkspaceIdCheckoutTriggerRoute,
  WorkspacesWorkspaceIdCreateBotRoute: WorkspacesWorkspaceIdCreateBotRoute,
  WorkspacesWorkspaceIdHomeRoute: WorkspacesWorkspaceIdHomeRoute,
  WorkspacesWorkspaceIdLoadingBotRoute: WorkspacesWorkspaceIdLoadingBotRoute,
  WorkspacesWorkspaceIdOnboardingRoute: WorkspacesWorkspaceIdOnboardingRoute,
  WorkspacesWorkspaceIdProfileRoute:
    WorkspacesWorkspaceIdProfileRouteWithChildren,
  WorkspacesWorkspaceIdSettingsRoute:
    WorkspacesWorkspaceIdSettingsRouteWithChildren,
  WorkspacesWorkspaceIdUsageRoute: WorkspacesWorkspaceIdUsageRouteWithChildren,
  WorkspacesWorkspaceIdIndexRoute: WorkspacesWorkspaceIdIndexRoute,
  WorkspacesWorkspaceIdBotsBotIdRoute:
    WorkspacesWorkspaceIdBotsBotIdRouteWithChildren,
  WorkspacesWorkspaceIdChatbotsBotIdRoute:
    WorkspacesWorkspaceIdChatbotsBotIdRouteWithChildren,
  WorkspacesWorkspaceIdIntegrationsIntegrationIdRoute:
    WorkspacesWorkspaceIdIntegrationsIntegrationIdRouteWithChildren,
  WorkspacesWorkspaceIdIntegrationsIndexRoute:
    WorkspacesWorkspaceIdIntegrationsIndexRoute,
}

const WorkspacesWorkspaceIdRouteWithChildren =
  WorkspacesWorkspaceIdRoute._addFileChildren(
    WorkspacesWorkspaceIdRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SplatRoute: SplatRoute,
  CheckoutRoute: CheckoutRoute,
  CliLoginRoute: CliLoginRoute,
  ForbiddenRoute: ForbiddenRoute,
  WelcomeRoute: WelcomeRoute,
  OauthInterstitialRoute: OauthInterstitialRoute,
  ProfileAccountRoute: ProfileAccountRoute,
  ProfileSettingsRoute: ProfileSettingsRoute,
  WorkspacesWorkspaceIdRoute: WorkspacesWorkspaceIdRouteWithChildren,
  WorkspacesIndexRoute: WorkspacesIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
